import { store } from '_helpers'
import { SPEECH_OUTCOME_CONSTANTS } from '_constants'

export class NoteValidationEngine {
    static state = undefined;
    static noteId = undefined;
    static noteType = undefined;
    static pk = undefined;
    static asno = undefined;
    static mhno = undefined;
    static epno = undefined;
    static oono = undefined;
    static errors = undefined;
    static isWc = undefined;
    static isWp = undefined;
    static isPainRequired = undefined;
    static cnRequiresTime = undefined;
    static usePSQ = undefined;
    static psqno = undefined;
    static table = undefined;
    static prefix = undefined;
    static xlno = undefined;
    static scribing = undefined;
    static isSpeech = undefined;

    static getErrors() {
        this.initEngine();

        if (this.isWp) {
            //Subjective
            this.fillSubjectiveTextAreaErrors();
            this.fillSubjectiveHistoryErrors();
            this.fillSubjectivePrevTherErrors();
            this.fillSubjectivePainRatingErrors();
            this.fillSubjectiveWorkCompErrors();
            //Objective
            this.fillObjectiveTemplateSelectionErrors();
            this.fillObjectiveMaterialHandlingErrors();
            this.fillObjectiveCardioErrors();
            this.fillObjectiveOutcomesErrors();
            //Activity Log
            this.fillWpAlErrors();
            //Goals
            this.GoalsErrors();
            //Assessment
            this.fillAssessmentWpErrors();
            //Plan
            this.fillWpPlanErrors();
            //Charges
            this.fillChargeErrors();
        } else {
            if (this.noteType === 22) {
                this.fillMissedVisitsErrors();
            } else {
                this.fillContraindicationErrors();
                if (this.noteType !== 4) {
                    this.fillSubjectiveErrors();
                    this.fillObjectiveErrors();
                } else {
                    this.fillPDCErrors();
                }

                this.fillAlErrors();
                this.fillGoalErrors();
                this.fillAssessmentErrors();
                this.fillPlanErrors();
                this.fillChargesErrors();

            }
        }


        return this.errors;
    }

    static getWpAlErrors() {
        this.initEngine();
        this.fillWpAlErrors();

        return this.errors;
    }

    static getAlErrors() {
        this.initEngine();
        this.fillAlErrors();

        return this.errors;
    }

    static getGroupErrors() {
        this.initEngine();
        this.fillGroupErrors();

        return this.errors;
    }

    static initEngine() {

        this.errors = [];
        this.state = store.getState();
        this.noteId = this.state.ui.patientTabs[this.state.ui.patientCenter[this.state.ui.patients.selectedPtno].selectedTab].noteId;
        this.noteType = parseInt(this.noteId.split("_")[0]);
        this.pk = parseInt(this.noteId.split("_")[1]);
        this.epno = this.noteType === 1 ? this.state.entities.notes.PTEVAL[this.pk].EVEPNO : this.state.entities.notes.PTNOTE[this.pk].NTEPNO;
        this.isCwsOrigin = this.noteType !== 1 && this.state.entities.notes.PTNOTE[this.pk].NTMNNO !== null ? true : false;
        this.isWc = this.state.entities.admissions[this.epno].isWc;
        this.isWp = this.state.entities.admissions[this.epno].isWP;
        this.isPainRequired = this.state.entities.admissions[this.epno].isPainRequired;
        this.cnRequiresTime = this.state.entities.admissions[this.epno].cnRequiresTime;
        this.usePSQ = this.state.entities.admissions[this.epno].usePsq;
        this.prefix = this.noteType === 1 ? 'EV' : 'NT';
        this.table = this.noteType === 1 ? 'PTEVAL' : 'PTNOTE';

        this.asno = parseInt(Object.keys(this.state.entities.notes.PTASSESSMENT)
            .find(key => (this.state.entities.notes.PTASSESSMENT[key].ASEVNO === this.pk && this.noteType === 1)
                || (this.state.entities.notes.PTASSESSMENT[key].ASNTNO === this.pk && this.noteType !== 1)));

        this.xlno = parseInt(Object.keys(this.state.entities.notes.MLEXLOG)
            .find(key => (this.state.entities.notes.MLEXLOG[key].XLEVNO === this.pk && this.noteType === 1)
                || (this.state.entities.notes.MLEXLOG[key].XLNTNO === this.pk && this.noteType !== 1)));

        this.mhno = parseInt(Object.keys(this.state.entities.notes.PTOBJECTIVEMATHAND)
            .find(key => (this.state.entities.notes.PTOBJECTIVEMATHAND[key].MHEVNO === this.pk && this.noteType === 1)
                || (this.state.entities.notes.PTOBJECTIVEMATHAND[key].MHNTNO === this.pk && this.noteType !== 1)));

        this.oono = parseInt(Object.keys(this.state.entities.notes.PTOBJECTIVEOBS)
            .find(key => (this.state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === this.pk && this.noteType === 1)
                || (this.state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === this.pk && this.noteType !== 1)));

        let addUser = this.noteType === 1 ? this.state.entities.notes.PTEVAL[this.pk].EVADDUSER : this.state.entities.notes.PTNOTE[this.pk].NTADDUSER;
        this.scribing = addUser === this.state.entities.authentication.user.urno ? false : true;

        let isSpeechEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
        this.isSpeech = this.state.entities.admissions[this.epno].discipline === "ST" && isSpeechEnabled;
    }

    static fillContraindicationErrors() {
        if (this.noteType === 1) {
            if (!this.state.entities.notes.PTEVAL[this.pk].EVCONTRAIN) {
                if (!this.state.entities.notes.PTEVAL[this.pk].EVCONTRAIN) {
                    this.errors.push({ section: 'Contraindications', label: 'Required or must select none', to: '' });
                }
            }
        }
        else if (this.noteType === 22) //Missed Visits
        {
            if (!this.state.entities.notes.PTNOTE[this.pk].NTCLINICALTYPE) {
                this.errors.push({ section: 'Contraindications', label: 'Clinical type is required', to: '' });
            }

            if (!this.state.entities.notes.PTNOTE[this.pk].NTMEASUREMENTDATE) {
                this.errors.push({ section: 'Contraindications', label: 'Measurement date is required', to: '' });
            }
        }
        else {
            if (!this.state.entities.notes.PTNOTE[this.pk].NTCONTRAIN) {
                this.errors.push({ section: 'Contraindications', label: 'Required or must select none', to: '' });
            }
        }
    }

    static fillMissedVisitsErrors() {
        if (!this.state.entities.notes.PTNOTE[this.pk].NTMISSEDVISITDESC) {
            this.errors.push({ section: 'MissedVisits', label: 'Description is required', to: '' });
        }

        if (!this.state.entities.notes.PTNOTE[this.pk].NTMEASUREMENTDATE) {
            this.errors.push({ section: 'MissedVisits', label: 'Measurement date is required', to: '' });
        }
    }

    static fillSubjectiveHistoryErrors() {
        if (this.noteType === 1) { //Eval
            if (!this.state.entities.notes.PTEVAL[this.pk]?.EVSUBHISDETAILS) {
                this.errors.push({ section: 'Subjective', label: 'History - Work Injury Details', to: 'subjective/subj_history/subj_hist_details' });
            }

            if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDDOMARM) {
                this.errors.push({ section: 'Subjective', label: 'History - Dominant Arm', to: 'subjective/subj_history/subj_medhis_involvedside' });
            }

            if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDINVOLVEDSIDE) {
                this.errors.push({ section: 'Subjective', label: 'History - Involved Side', to: 'subjective/subj_history/subj_medhis_involvedside' });
            }
        }

    }

    static fillSubjectiveTextAreaErrors() {
        if (this.noteType !== 1) {
            let count = Object.keys(this.state.entities.notes.PTSUBJECTIVE)
                .filter(key => {
                    return (this.state.entities.notes.PTSUBJECTIVE[key].SUNTNO === this.pk &&
                        (
                            this.state.entities.notes.PTSUBJECTIVE[key]?.SUDETAILS === null
                        )
                    )
                }).length;

            if (count > 0) {
                this.errors.push({ section: 'Subjective', label: 'Subjective is required', to: 'subjective' });
            }
        }

    }

    static fillSubjectivePrevTherErrors() {
        if (this.noteType === 1) { //Eval
            if (this.state.entities.notes.PTEVAL[this.pk].EVSUBPREVSAME === null ||
                this.state.entities.notes.PTEVAL[this.pk].EVSUBPREVSAME === undefined ||
                (this.state.entities.notes.PTEVAL[this.pk].EVSUBPREVSAME === true &&
                    (
                        this.state.entities.notes.PTEVAL[this.pk].EVSUBPREVSUCCESS === null ||
                        this.state.entities.notes.PTEVAL[this.pk].EVSUBPREVSUCCESS === undefined
                    )
                )
            ) {
                this.errors.push({ section: 'Subjective', label: 'Previous Therapy', to: 'subjective/subj_history/subj_prev_ther' });
            }
        }
    }

    static fillSubjectivePainRatingErrors() {
        if (this.noteType === 2) {
            if (!this.state.entities.notes[this.table][this.pk][this.prefix + 'SUBPAINCURRENT']) {
                this.errors.push({ section: 'Subjective', label: 'Pain Rating - Current', to: 'subjective/sub_pain' });
            }
        } else if (this.noteType !== 4) {
            if (!this.state.entities.notes[this.table][this.pk][this.prefix + 'SUBPAINBEST']) {
                this.errors.push({ section: 'Subjective', label: 'Pain Rating - Best', to: 'subjective/sub_pain' });
            }
            if (!this.state.entities.notes[this.table][this.pk][this.prefix + 'SUBPAINWORST']) {
                this.errors.push({ section: 'Subjective', label: 'Pain Rating - Worst', to: 'subjective/sub_pain' });
            }
            if (!this.state.entities.notes[this.table][this.pk][this.prefix + 'SUBPAINCURRENT']) {
                this.errors.push({ section: 'Subjective', label: 'Pain Rating - Current', to: 'subjective/sub_pain' });
            }
        }
    }

    static fillSubjectiveWorkCompErrors() {

        if (!this.state.entities.notes[this.table][this.pk][this.prefix + 'SUBWCOCCUPATION']) {
            this.errors.push({ section: 'Subjective', label: 'Work Comp - Occupation', to: 'subjective/subj_workComp' });
        }

        if (!this.state.entities.notes[this.table][this.pk][this.prefix + 'SUBWCSTATUS']) {
            this.errors.push({ section: 'Subjective', label: 'Work Comp - Status', to: 'subjective/subj_workComp' });
        }

        if (!this.state.entities.notes[this.table][this.pk][this.prefix + 'SUBWCDOLJOBREQLIFTFREQ']) {
            this.errors.push({ section: 'Subjective', label: 'Job Required - Lift Freq.', to: 'subjective/subj_wc_job_pdc' });
        }

        if (!this.state.entities.notes[this.table][this.pk][this.prefix + 'SUBWCDOLJOBREQLIFT']) {
            this.errors.push({ section: 'Subjective', label: 'Job Required - Lift', to: 'subjective/subj_wc_job_pdc' });
        }

        if (!this.state.entities.notes[this.table][this.pk][this.prefix + 'SUBWCGOALPDC']) {
            this.errors.push({ section: 'Subjective', label: 'Goal PDC - PDC Level', to: 'subjective/subj_wc_job_pdc' });
        }

        if (this.noteType !== 1 && this.noteType !== 2) {
            if (!this.state.entities.notes[this.table][this.pk][this.prefix + 'SUBWCDOLCURRENTLIFTFREQ']) {
                this.errors.push({ section: 'Subjective', label: 'Current PDC - Lift Freq.', to: 'subjective/subj_wc_current_pdc' });
            }

            if (!this.state.entities.notes[this.table][this.pk][this.prefix + 'SUBWCDOLCURRENTLIFT']) {
                this.errors.push({ section: 'Subjective', label: 'Current PDC - Lift', to: 'subjective/subj_wc_current_pdc' });
            }
        }

    }

    static fillObjectiveCardioErrors() {
        if (this.noteType === 1) {
            if (!this.state.entities.notes.PTOBJECTIVEOBS[this.oono].OOCARDIONOTTESTED) {

                if (!this.state.entities.notes.PTOBJECTIVEOBS[this.oono].OOCARDIOPREHR || !this.state.entities.notes.PTOBJECTIVEOBS[this.oono].OOCARDIOPREBPSYS || !this.state.entities.notes.PTOBJECTIVEOBS[this.oono].OOCARDIOPREBPDIAS) {
                    this.errors.push({ section: 'Objective', label: 'Cardiovascular - Pre-Test required', to: 'objective/obj_car' });
                }

            } else {
                if (this.state.entities.notes.PTOBJECTIVEOBS[this.oono].OOCARDIONOTTESTEDREASON === null || this.state.entities.notes.PTOBJECTIVEOBS[this.oono].OOCARDIONOTTESTEDREASON === '') {
                    this.errors.push({ section: 'Objective', label: 'Reason BP is required', to: 'objective/obj_car' });
                }
            }

            if (this.state.entities.notes.PTOBJECTIVEOBS[this.oono].OOCARDIOONHOLD
                &&
                (this.state.entities.notes.PTOBJECTIVEOBS[this.oono].OOCARDIOONHOLDREASON === null
                    || this.state.entities.notes.PTOBJECTIVEOBS[this.oono].OOCARDIOONHOLDREASON === '')) {
                this.errors.push({ section: 'Objective', label: 'Reason is required', to: 'objective/obj_car' });
            }
        }
    }

    static fillObjectiveOutcomesErrors() {
        let isPeds = this.state.entities.admissions[this.epno].isPeds;
        let isPedsEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
        let isPedsSpeech = this.state.entities.admissions[this.epno].isPedsSpeech;
        let isSpeechEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;

        let outRequired = true;

        if (this.noteType === 2 && ((isPeds && isPedsEnabled) || (isPedsSpeech && isSpeechEnabled))) {
            outRequired = false;
        }

        // must have at least one template selected
        let count = Object.keys(this.state.entities.notes.PTOBJECTIVETEMPLATESXREF)
            .filter(key => {
                return (this.noteType === 1 && this.state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBEVNO === this.pk) ||
                    (this.noteType !== 1 && this.state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBNTNO === this.pk)
            }).length;

        if (this.noteType !== 4) {
            // outcome measures
            count = Object.keys(this.state.entities.notes.PTOUTMEASURES)
                .filter(key => {
                    return ((this.noteType === 1 && this.state.entities.notes.PTOUTMEASURES[key].OMEVNO === this.pk) ||
                        (this.noteType !== 1 && this.state.entities.notes.PTOUTMEASURES[key].OMNTNO === this.pk))
                }).length;

            if (count === 0 && !this.state.entities.notes[this.table][this.pk][this.prefix + 'OBJNOOUTCOMEREASON'] && outRequired) {
                this.errors.push({ section: 'Objective', label: 'Outcome Measures', to: 'objective/obj_outmeasures' });
            }


            if (count > 0) {
                count = Object.keys(this.state.entities.notes.PTOUTMEASURES)
                    .filter(key => {
                        return (((this.noteType === 1 && this.state.entities.notes.PTOUTMEASURES[key].OMEVNO === this.pk) ||
                            (this.noteType !== 1 && this.state.entities.notes.PTOUTMEASURES[key].OMNTNO === this.pk)) &&
                            (!this.state.entities.notes.PTOUTMEASURES[key].OMNAME //if name is null
                                ||
                                (((this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== SPEECH_OUTCOME_CONSTANTS.GFTA_3 &&  //if not one of the "special peds"
                                    this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== SPEECH_OUTCOME_CONSTANTS.CELF_5 &&
                                    this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== SPEECH_OUTCOME_CONSTANTS.CELFP_2 &&
                                    this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== SPEECH_OUTCOME_CONSTANTS.CAAP_2 &&
                                    this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== SPEECH_OUTCOME_CONSTANTS.ROSSETTI_SCALE &&
                                    this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== 'Peabody (PDMS3)') || this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO === 47)
                                    &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMSCORE)
                                ||
                                (this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.GFTA_3 && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 && //if is GFTA_3
                                    (!this.state.entities.notes.PTOUTMEASURES[key].OMSOUNDINWORD || !this.state.entities.notes.PTOUTMEASURES[key].OMSOUNDINSENTENCE)
                                )
                                ||
                                ((this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.CELF_5 || this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.CELFP_2) && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 && //celf5 & 2
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMCORELANGSCORE
                                )
                                ||
                                (this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.CAAP_2 && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 &&
                                    (!this.state.entities.notes.PTOUTMEASURES[key].OMCONSTANTINV || !this.state.entities.notes.PTOUTMEASURES[key].OMPHONOPROCESS)
                                )
                                ||
                                (this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.ROSSETTI_SCALE && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 &&
                                    (!this.state.entities.notes.PTOUTMEASURES[key].OMEXPRESSIVELAND || !this.state.entities.notes.PTOUTMEASURES[key].OMRECEPTIVELANG)
                                )
                                ||
                                (this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.isFcpR && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMSEVERITY
                                ) ||
                                (this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === 'Peabody (PDMS3)' && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMBODYCONTROLRAW &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMBODYTRANSRAW &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMOBJECTCONTROLRAW &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMHANDMANCONTROLRAW &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMHANDEYECONTROLRAW
                                )
                            )
                        )
                    }).length;

                //need to check if the outcome is peds specific, and not using the OBJNOOUTCOMEREASON
                if (count > 0 && !this.state.entities.notes[this.table][this.pk][this.prefix + 'OBJNOOUTCOMEREASON'] && outRequired) {
                    this.errors.push({ section: 'Objective', label: 'Outcome Measures - required fields', to: 'objective/obj_outmeasures' });
                }

            }

            // Make sure any asterisk signs are complete
            if (this.noteType === 2 || this.noteType === 3 || this.noteType === 5) { // only DN and PN

                let count = Object.keys(this.state.entities.notes.PTOBJECTIVEASTERISKS)
                    .filter(key => {
                        return (this.state.entities.notes.PTOBJECTIVEASTERISKS[key].OANTNO === this.pk &&
                            (
                                this.state.entities.notes.PTOBJECTIVEASTERISKS[key].OAASTERISK === null ||
                                this.state.entities.notes.PTOBJECTIVEASTERISKS[key].OAPREINT === null ||
                                this.state.entities.notes.PTOBJECTIVEASTERISKS[key].OAPOSTINT === null
                            )
                        )
                    }).length;

                if (count > 0) {
                    this.errors.push({ section: 'Objective', label: 'Complete asterisk signs', to: 'objective/obj_asterisks' });
                }
            }
        }
    }

    static fillObjectiveTemplateSelectionErrors() {
        let globalTemplates = Object.keys(this.state.entities.notes.PTOBJECTIVETEMPLATES)
            .filter(key => {
                return this.state.entities.notes.PTOBJECTIVETEMPLATES[key].TEURNO === null
                    &&
                    this.state.entities.notes.PTOBJECTIVETEMPLATES[key].NoteId === this.noteId
                    &&
                    this.state.entities.notes.PTOBJECTIVETEMPLATES[key].TEISWP
            })
            .sort((a, b) => this.state.entities.notes.PTOBJECTIVETEMPLATES[a].TENAME.localeCompare(this.state.entities.notes.PTOBJECTIVETEMPLATES[b].TENAME))
            .map(key => this.state.entities.notes.PTOBJECTIVETEMPLATES[key]);

        let globalTemplateIds = Object.keys(globalTemplates).map(x => globalTemplates[x].TENO);

        let globalTemplateSelectedCount = Object.keys(this.state.entities.notes.PTOBJECTIVETEMPLATESXREF)
            .filter(x => (
                (this.noteType === 1 && this.state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBEVNO === this.pk) ||
                (this.noteType !== 1 && this.state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBNTNO === this.pk)
            ) && globalTemplateIds.includes(this.state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBTENO)
            ).length;

        if (globalTemplateSelectedCount === 0) {
            this.errors.push({ section: 'Objective', label: 'Atleast one template is required', to: 'objective/obj_templates_global' });
        }
    }

    static fillObjectiveMaterialHandlingErrors() {
        if (this.noteType !== 2 && this.noteType !== 4) { // not DN or PN
            const notes = this.state.entities.notes['PTOBJECTIVEMATHAND'][this.mhno];

            const materialHandlingChecks = [
                {
                    label: 'Floor to waist',
                    fields: ['MHFLTOWAJOBLBS', 'MHFLTOWAJOBTXT', 'MHFLTOWACURLBS', 'MHFLTOWACURTXT']
                },
                {
                    label: 'Waist to shoulder',
                    fields: ['MHWATOSHJOBLBS', 'MHWATOSHJOBTXT', 'MHWATOSHCURLBS', 'MHWATOSHCURTXT']
                },
                {
                    label: 'Carry 50 ft.',
                    fields: ['MHCARRYJOBLBS', 'MHCARRYJOBTXT', 'MHCARRYCURLBS', 'MHCARRYCURTXT']
                }
            ];

            materialHandlingChecks.forEach(({ label, fields }) => {
                const missingField = fields.some(field => notes[field] == null);
                if (missingField) {
                    this.errors.push({ section: 'Objective', label: 'Material Handling - ' + label, to: 'objective/obj_materialHandling' });
                }
            });

        }

    }

    static GoalsErrors() {
        let ltgMin = parseInt(this.state.entities.masterData.PROPS['WP_LTG_MIN'].PRVALUE);
        let stgMin = parseInt(this.state.entities.masterData.PROPS['WP_STG_MIN'].PRVALUE);
        if (this.noteType === 1) { //Eval
            if (this.state.entities.notes.PTSHORTGOALS) {
                const shortGoalKeys = Object.keys(this.state.entities.notes.PTSHORTGOALS)
                    .filter(key => {
                        const goal = this.state.entities.notes.PTSHORTGOALS[key];
                        return (
                            goal?.SGEVNO === this.pk && // PK matches
                            goal.SGACTIVE && // STG is active
                            (
                                !goal.SGDESC || // Description is empty
                                !goal.SGDATE   // Date is empty
                            )
                        );
                    });
                shortGoalKeys.forEach(key => {
                    const goal = this.state.entities.notes.PTSHORTGOALS[key];
                    const stGoalName = goal.SGNAME ?? (goal.SGDESC ?? '<Short Term Goal Not Defined>');
                    this.errors.push({
                        section: 'Goals',
                        label: stGoalName,
                        to: 'goals/sgno_' + goal.SGNO
                    });
                });

                const shortGoalsMinKeys = Object.keys(this.state.entities.notes.PTSHORTGOALS)
                    .filter(key => {
                        const goal = this.state.entities.notes.PTSHORTGOALS[key];
                        return (
                            goal?.SGEVNO === this.pk && // PK matches
                            goal.SGACTIVE
                        );
                    });

                if (shortGoalsMinKeys.length < stgMin) {

                    this.errors.push({
                        section: 'Goals',
                        label: `Minimum ${stgMin} STG Required`,
                        to: 'GoalsSection'
                    });
                }

            }

            if (this.state.entities.notes.PTGOALS) {
                Object.keys(this.state.entities.notes.PTGOALS)
                    .filter(key => {
                        if (this.state.entities.notes.PTGOALS[key]?.GOEVNO === this.pk &&
                            this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                            (
                                !this.state.entities.notes.PTGOALS[key].GOOBJECTIVE || //description is empty
                                !this.state.entities.notes.PTGOALS[key].GODATE //date is empty
                            )
                        ) {
                            return true;
                        }
                        return false;
                    })
                    .forEach(key => {
                        let goal = this.state.entities.notes.PTGOALS[key];
                        const ltGoalName = goal.GOOBJECTIVE ?? '<Long Term Goal Not Defined>';
                        this.errors.push({
                            section: 'Goals',
                            label: ltGoalName,
                            to: 'goals/goal_' + goal.GONO
                        });
                    });
                const allGoals = this.state.entities.notes.PTGOALS;

                const definedGoalCount = Object.values(allGoals).filter(goal => {
                    return (
                        goal?.GOEVNO === this.pk && goal.GODELETED !== true
                    );
                }).length;

                if (definedGoalCount < ltgMin) {

                    this.errors.push({
                        section: 'Goals',
                        label: `Minimum ${ltgMin} LTG Required`,
                        to: 'GoalsSection'
                    });
                }
            }
        } else {
            if (this.state.entities.notes.PTSHORTGOALS) {
                const shortGoalKeys = Object.keys(this.state.entities.notes.PTSHORTGOALS)
                    .filter(key => {
                        const goal = this.state.entities.notes.PTSHORTGOALS[key];
                        return (
                            goal?.SGNTNO === this.pk && // PK matches
                            goal.SGACTIVE && // STG is active
                            (
                                !goal.SGDESC || // Description is empty
                                !goal.SGDATE   // Date is empty
                                || !goal.SGGPNO
                            )
                        );
                    });
                shortGoalKeys.forEach(key => {
                    const goal = this.state.entities.notes.PTSHORTGOALS[key];
                    const stGoalName = goal.SGNAME ?? (goal.SGDESC ?? '<Not Defined>');
                    this.errors.push({
                        section: 'Goals',
                        label: "STG - " + stGoalName + (goal.SGGPNO === null ? " - Progress is Required" : ""),
                        to: 'goals/sgno_' + goal.SGNO
                    });
                });

                const shortGoalsMinKeys = Object.keys(this.state.entities.notes.PTSHORTGOALS)
                    .filter(key => {
                        const goal = this.state.entities.notes.PTSHORTGOALS[key];
                        return (
                            goal?.SGNTNO === this.pk && // PK matches
                            goal.SGACTIVE
                        );
                    });

                if (shortGoalsMinKeys.length < stgMin) {

                    this.errors.push({
                        section: 'Goals',
                        label: `Minimum ${stgMin} STG Required`,
                        to: 'GoalsSection'
                    });
                }

            }

            if (this.state.entities.notes.PTGOALS) {
                Object.keys(this.state.entities.notes.PTGOALS)
                    .filter(key => {
                        if (this.state.entities.notes.PTGOALS[key]?.GONTNO === this.pk &&
                            this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                            (
                                !this.state.entities.notes.PTGOALS[key].GOOBJECTIVE || //description is empty
                                !this.state.entities.notes.PTGOALS[key].GODATE //date is empty
                                || !this.state.entities.notes.PTGOALS[key].GOGPNO
                            )
                        ) {
                            return true;
                        }
                        return false;
                    })
                    .forEach(key => {
                        let goal = this.state.entities.notes.PTGOALS[key];
                        const ltGoalName = goal.GOOBJECTIVE ?? '<Not Defined>';
                        this.errors.push({
                            section: 'Goals',
                            label: "LTG - " + ltGoalName + (goal.GOGPNO === null ? " - Progress is Required" : ""),
                            to: 'goals/goal_' + goal.GONO
                        });
                    });
                const allGoals = this.state.entities.notes.PTGOALS;

                const definedGoalCount = Object.values(allGoals).filter(goal => {
                    return (
                        goal?.GONTNO === this.pk &&
                        goal.GODELETED !== true
                    );
                }).length;

                if (definedGoalCount < ltgMin) {

                    this.errors.push({
                        section: 'Goals',
                        label: `Minimum ${ltgMin} LTG Required`,
                        to: 'GoalsSection'
                    });
                }
            }
        }

    }

    static fillChargeErrors() {
        if (this.noteType === 1) { // EVAL
            if (!this.scribing) {
                if (this.state.entities.authentication.user.isStudent) {
                    //check for CI 
                    if (!this.state.entities.notes.PTEVAL[this.pk].EVCITHNO) {
                        this.errors.push({ section: 'Charges', label: 'Clinical Instructor Required', to: 'charges' });
                    }
                    else {
                        //get selected CI and check if the are licensed
                        let selectedCI = Object.keys(this.state.entities.notes.CILIST)
                            .find(key => (this.state.entities.notes.CILIST[key].epno === this.epno && this.state.entities.notes.CILIST[key].THNO === this.state.entities.notes.PTEVAL[this.pk].EVCITHNO));

                        if (selectedCI !== undefined) {
                            if (!this.state.entities.notes.CILIST[selectedCI].TTISLICENSED && !this.state.entities.notes.PTEVAL[this.pk].EVTHNOSUPV) {
                                this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                            }
                        }
                    }
                }
                else if (!this.state.entities.authentication.user.islicensed &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVTHNOSUPV) {
                    this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                }
            }
            if (!this.state.entities.notes.PTEVAL[this.pk].EVTRTDATE) {
                this.errors.push({ section: 'Charges', label: 'Treatment Date Required', to: 'charges' });
            }
            if (!this.state.entities.notes.PTEVAL[this.pk].hasCharges) {
                // billable charges OR EVNOCHARGEREASON
                if (!this.state.entities.notes.PTEVAL[this.pk].EVNOCHARGEREASON &&
                    this.state.ui.notes[this.noteId].computedChargesVisible === false) {
                    this.errors.push({ section: 'Charges', label: 'Computed charges are required', to: 'charges' });
                } else if (!this.state.entities.notes.PTEVAL[this.pk].EVNOCHARGEREASON &&
                    this.state.ui.notes[this.noteId].computedChargesVisible === true &&
                    // mlcomputedcharges contains at least one CCBILLABLE
                    Object.keys(this.state.entities.notes.MLCOMPUTEDCHARGES)
                        .filter(key => this.state.entities.notes.MLCOMPUTEDCHARGES[key].CCCRNO === this.state.entities.notes.MLCHARGEREQUESTS[this.xlno].CRNO &&
                            this.state.entities.notes.MLCOMPUTEDCHARGES[key].CCBILLABLE === true).length === 0) {
                    this.errors.push({ section: 'Charges', label: 'Must have billable charge or specify reason for no charges', to: 'charges' });
                }
            }
        } else if (this.noteType === 2 || this.noteType === 5 || this.noteType === 6) { // DN, PN/DN, DC/DN
            if (!this.scribing) {
                if (this.state.entities.authentication.user.isStudent) {
                    //check for CI 
                    if (!this.state.entities.notes.PTNOTE[this.pk].NTCITHNO) {
                        this.errors.push({ section: 'Charges', label: 'Clinical Instructor Required', to: 'charges' });
                    }
                    else {
                        //get selected CI and check if the are licensed
                        let selectedCI = Object.keys(this.state.entities.notes.CILIST)
                            .find(key => (this.state.entities.notes.CILIST[key].epno === this.epno && this.state.entities.notes.CILIST[key].THNO === this.state.entities.notes.PTNOTE[this.pk].NTCITHNO));

                        if (selectedCI !== undefined) {
                            if (!this.state.entities.notes.CILIST[selectedCI].TTISLICENSED && !this.state.entities.notes.PTNOTE[this.pk].NTTHNOSUPV) {
                                this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                            }
                        }
                    }
                }
                else if (!this.state.entities.authentication.user.islicensed &&
                    !this.state.entities.notes.PTNOTE[this.pk].NTTHNOSUPV) {
                    this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                }
            }
            if (!this.state.entities.notes.PTNOTE[this.pk]?.NTTRTDATE) {
                this.errors.push({ section: 'Charges', label: 'Treatment Date Required', to: 'charges' });
            }

            if (!this.state.entities.notes.PTNOTE[this.pk].hasCharges) {
                // billable charges OR EVNOCHARGEREASON
                if (!this.state.entities.notes.PTNOTE[this.pk].NTNOCHARGEREASON &&
                    this.state.ui.notes[this.noteId].computedChargesVisible === false) {
                    this.errors.push({ section: 'Charges', label: 'Computed charges are required', to: 'charges' });
                } else if (!this.state.entities.notes.PTNOTE[this.pk].NTNOCHARGEREASON &&
                    this.state.ui.notes[this.noteId].computedChargesVisible === true &&
                    // mlcomputedcharges contains at least one CCBILLABLE
                    Object.keys(this.state.entities.notes.MLCOMPUTEDCHARGES)
                        .filter(key => this.state.entities.notes.MLCOMPUTEDCHARGES[key].CCCRNO === this.state.entities.notes.MLCHARGEREQUESTS[this.xlno].CRNO &&
                            this.state.entities.notes.MLCOMPUTEDCHARGES[key].CCBILLABLE === true).length === 0) {
                    this.errors.push({ section: 'Charges', label: 'Must have billable charge or specify reason for no charges', to: 'charges' });
                }
            }
        } else if (this.noteType === 3) {
            if (!this.state.entities.notes.PTNOTE[this.pk].NTMEASUREMENTDATE) {
                this.errors.push({ section: 'Charges', label: 'Measurement Date Required', to: 'charges' });
            }
            if (this.state.entities.authentication.user.isStudent) {
                //check for CI 
                if (!this.state.entities.notes.PTNOTE[this.pk].NTCITHNO) {
                    this.errors.push({ section: 'Charges', label: 'Clinical Instructor Required', to: 'charges' });
                }
                else {
                    //get selected CI and check if the are licensed
                    let selectedCI = Object.keys(this.state.entities.notes.CILIST)
                        .find(key => (this.state.entities.notes.CILIST[key].epno === this.epno && this.state.entities.notes.CILIST[key].THNO === this.state.entities.notes.PTNOTE[this.pk].NTCITHNO));

                    if (selectedCI !== undefined) {
                        if (!this.state.entities.notes.CILIST[selectedCI].TTISLICENSED && !this.state.entities.notes.PTNOTE[this.pk].NTTHNOSUPV) {
                            this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                        }
                    }
                }
            }
            else if (!this.scribing) {
                if (!this.state.entities.authentication.user.islicensed &&
                    !this.state.entities.notes.PTNOTE[this.pk].NTTHNOSUPV) {
                    this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                }
            }
        }
    }


    static fillSubjectiveErrors() {
        if (this.noteType === 1) {

            const onsetRaw = this.state.entities.notes.CPEPISODE[this.epno]?.EPDTONST;
            const treatmentRaw = this.state.entities.notes.PTEVAL[this.pk]?.EVTRTDATE;

            const result = OnSetTrtDtComp(onsetRaw, treatmentRaw);
            if (result) {
                this.errors.push({
                    section: 'Subjective',
                    label: 'History - Onset date should be less than or equal to Treatment date',
                    to: 'subjective/subj_history/subj_hist'
                });
            }
            let isPeds = this.state.entities.admissions[this.epno].isPeds;
            let isPedsEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;

            if (!isPeds || !isPedsEnabled) {
                // medical history
                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDINVOLVEDSIDE) {
                    this.errors.push({ section: 'Subjective', label: 'History - Involved Side', to: 'subjective/subj_history/subj_medhis_involvedside' });
                }
                // history
                if (!this.state.entities.notes.CPEPISODE[this.epno].EPDTONST) {
                    this.errors.push({ section: 'Subjective', label: 'History - Onset Date', to: 'subjective/subj_history/subj_hist' });
                }
            }

            if (!this.state.entities.notes.PTEVAL[this.pk]?.EVSUBHISDETAILS) {
                this.errors.push({ section: 'Subjective', label: 'History - Details', to: 'subjective/subj_history/subj_hist_details' });
            }

            if (isPeds && isPedsEnabled) {

                let evpno = Object.keys(this.state.entities.notes.PTEVALPEDS)
                    //peds info
                    .find(key => (this.state.entities.notes.PTEVALPEDS[key].EVPEVNO === this.pk));

                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMNONE &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMADHD &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMANEMIA &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMALLERGIES &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMANXIETY &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMARTHITIS &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMASTHMA &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMAUTISM &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMHEADACHES &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMHEARING &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMHEART &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMHIGHBLOOD &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMHYPERTONIA &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMHYPOTONIA &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMKIDNEY &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMCANCER &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMCEREBRAL &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMCONSTIPATION &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMDEPRESSION &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMDIABETES &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMEPILEPSY &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMMUSCULAR &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMREFLUX &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMSPINA &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMSTROKE &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMTHYROID &&
                    !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMVISION &&
                    (!this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMOTHER ||
                        (this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMOTHER
                            && this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMOTHERDETAILS === null))) {
                    if (this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMOTHER
                        && this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMOTHERDETAILS === null) {
                        this.errors.push({ section: 'Subjective', label: 'Comorbidities - Other Details', to: 'subjective/subj_history/sub_med_hist_comorb' });
                    }
                    else {
                        this.errors.push({ section: 'Subjective', label: 'Comorbidities', to: 'subjective/subj_history/sub_med_hist_comorb' });
                    }
                }

                if (!this.state.entities.notes.PTEVALPEDS[evpno].EVPINFOPLACEOFSERVICE) {
                    this.errors.push({ section: 'Subjective', label: 'Place of Service', to: 'subjective/subj_history/sub_med_hist_peds_place' });
                }

                //previous treatment 
                if (this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVTREATEDPREV === null || (this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVTREATEDPREV && this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVTREATEDPREVHELP === null)) {
                    this.errors.push({ section: 'Subjective', label: 'Previous Treatment', to: 'subjective/subj_history/sub_med_hist_prev' });
                }

                if ((this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVEARLYINT && !this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVEARLYINTDETAILS) ||
                    (this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVHOSPITAL && !this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVHISPITALDETAILS) ||
                    (this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVSCHOOL && !this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVSCHOOLDETAILS) ||
                    (this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVOTHER && !this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVOTHERDETAILS) ||
                    (this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVOTHER && !this.state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVOTHERDETAILS)) {
                    this.errors.push({ section: 'Subjective', label: 'Previous Treatment details', to: 'subjective/subj_history/sub_med_hist_prev' });
                }

                if ((this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBHISTCAFFINE && !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBSHISTCAFFINEPERDAY)) {
                    this.errors.push({ section: 'Subjective', label: 'Past Medical History', to: 'subjective/subj_history/sub_med_hist_past' });
                }

                //birth history
                if (this.state.entities.notes.PTEVALPEDS[evpno].EVPBIRTHHISTPREGCOMP === null || (this.state.entities.notes.PTEVALPEDS[evpno].EVPBIRTHHISTPREGCOMP === true && !this.state.entities.notes.PTEVALPEDS[evpno].EVPBIRTHHISTPREGCOMPDETAILS)) {

                    this.errors.push({ section: 'Subjective', label: 'Birth History Details - Complications with Pregnancy', to: 'subjective/subj_history/sub_med_hist_birth' });
                }

                if (this.state.entities.notes.PTEVALPEDS[evpno].EVPBIRTHHISTEARLY === null) {
                    this.errors.push({ section: 'Subjective', label: 'Birth History Details - Early or Late', to: 'subjective/subj_history/sub_med_hist_birth' });
                }
                if (this.state.entities.notes.PTEVALPEDS[evpno].EVPBIRTHHISTCOMPDELIVERY === null || (this.state.entities.notes.PTEVALPEDS[evpno].EVPBIRTHHISTCOMPDELIVERY && !this.state.entities.notes.PTEVALPEDS[evpno].EVPBIRTHHISTCOMPDELIVERYDETAILS)) {
                    this.errors.push({ section: 'Subjective', label: 'Birth History Details - Complications with Birth', to: 'subjective/subj_history/sub_med_hist_birth' });
                }

                if (this.state.entities.notes.PTEVALPEDS[evpno].EVPBIRTHHISTREMAININHOSP === null) {
                    this.errors.push({ section: 'Subjective', label: 'Birth History Details - Hospital Stay', to: 'subjective/subj_history/sub_med_hist_birth' });
                }
                if (this.state.entities.admissions[this.epno].primaryPYNO + "" === this.state.entities.masterData.PROPS['SAPPHIRE_CDSA_PYNO'].PRVALUE) {
                    if ((!this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSANEWINJ &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSAONGOINGINJ &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSAEXACINJ &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSARESCHANGE &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSANEWEQUIP &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSANEWCARE &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSANEWCARE &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSAOTHER) ||
                        (this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSAOTHER && this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSAOTHERDETAILS === null)) {
                        this.errors.push({ section: 'Subjective', label: 'CDSA: Reason for referral', to: 'subjective/subj_history/sub_med_hist_CDSA_reason' });
                    }


                    if (!this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSANOPREV &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSAYESPREV &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSATHISPROVDC &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSATHISPROVDIFDC &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSAANOTHERPROVDC &&
                        !this.state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCDSAANOTHERCUR) {
                        this.errors.push({ section: 'Subjective', label: 'CDSA: History of Previous Therapy', to: 'subjective/subj_history/sub_med_hist_CDSA_prev' });
                    }
                }


            } else {
                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMNONE &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMALLERGIES &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMANGINA &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMANXIETY &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMARTHRITIS &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMASTHMA &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMBACKPAIN &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMCANCER &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMCOPD &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMHEARTDIS &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMDEPRESS &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMDIABETES &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMGASTO &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMHEADACHE &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMHEAR &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMHEARTATT &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMBLOOD &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMHIGHBP &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMINCONT &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMKIDNEY &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMNEURO &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMOSTEO &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMOTHDIS &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMPACE &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMVASC &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMPREVACC &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMSURGERY &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMPROSTHESIS &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMSEIZURE &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMSLEEPDYS &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMSTROKE &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMVISUAL &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMTOBACCO &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMOTHER

                ) {
                    this.errors.push({ section: 'Subjective', label: 'Comorbidities', to: 'subjective/subj_history/sub_med_hist_comorb' });
                }
            }
            if (this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMALLERGIES &&
                !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCOMALLERGY) {
                this.errors.push({ section: 'Subjective', label: 'Comorbidities - Allergies', to: 'subjective/subj_history/sub_med_hist_comorb' });
            }

            if (isPeds && isPedsEnabled) {
                // vitals





            }

            // prev therapy
            if (!isPeds || !isPedsEnabled) {
                if (this.state.entities.notes.PTEVAL[this.pk].EVSUBPREVSAME === null ||
                    this.state.entities.notes.PTEVAL[this.pk].EVSUBPREVSAME === undefined ||
                    (this.state.entities.notes.PTEVAL[this.pk].EVSUBPREVSAME === true &&
                        (
                            this.state.entities.notes.PTEVAL[this.pk].EVSUBPREVSUCCESS === null ||
                            this.state.entities.notes.PTEVAL[this.pk].EVSUBPREVSUCCESS === undefined
                        )
                    )
                ) {
                    this.errors.push({ section: 'Subjective', label: 'Previous Therapy', to: 'subjective/subj_history/subj_prev_ther' });
                }
            }

            // social history
            if (this.state.entities.notes.PTEVAL[this.pk].EVSUBSOCLIVEWITH === null ||
                this.state.entities.notes.PTEVAL[this.pk].EVSUBSOCLIVEWITH === undefined ||
                (this.state.entities.notes.PTEVAL[this.pk].EVSUBSOCLIVEWITH === 6 &&
                    (
                        this.state.entities.notes.PTEVAL[this.pk].EVSUBSOCLIVESOTHER === null ||
                        this.state.entities.notes.PTEVAL[this.pk].EVSUBSOCLIVESOTHER === undefined
                    )
                )
            ) {
                this.errors.push({ section: 'Subjective', label: 'Social History', to: 'subjective/subj_history/subj_social' });
            }


            // work comp
            if (this.isWc) {
                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBWCOCCUPATION) {
                    this.errors.push({ section: 'Subjective', label: 'Work Comp - Occupation', to: 'subjective/subj_wc' });
                }
                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBWCSTATUS) {
                    this.errors.push({ section: 'Subjective', label: 'Work Comp - Status', to: 'subjective/subj_wc' });
                }
                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBWCDOLJOBREQLIFTFREQ ||
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBWCDOLJOBREQLIFT) {
                    this.errors.push({ section: 'Subjective', label: 'Work Comp - Job Required PDC', to: 'subjective/subj_wc/subj_wc_job_req_pdc' });
                }

                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBWCDOLCURRENTLIFTFREQ ||
                    !this.state.entities.notes.PTEVAL[this.pk].EVSUBWCDOLCURRENTLIFT) {
                    this.errors.push({ section: 'Subjective', label: 'Work Comp - Current PDC', to: 'subjective/subj_wc/subj_wc_current_pdc' });
                }

                if (this.state.entities.notes.PTEVAL[this.pk].EVSUBWCODG === undefined ||
                    this.state.entities.notes.PTEVAL[this.pk].EVSUBWCODG === null) {
                    this.errors.push({ section: 'Subjective', label: 'Work Comp - ODG Analysis', to: 'subjective/subj_wc/subj_wc_odg' });
                }
            } // isWc


            // pain rating
            if (this.isWc || this.isPainRequired) {
                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBPAINCURRENT) {
                    this.errors.push({ section: 'Subjective', label: 'Pain Rating - Current', to: 'subjectve/sub_pain' });
                }
            }


            // PSQ
            if (this.usePSQ) {
                let psqno = Object.keys(this.state.entities.notes.CWPAINSCREENING)
                    .find(key => (this.state.entities.notes.CWPAINSCREENING[key].PSQEVNO === this.pk));
                if (!this.state.entities.notes.CWPAINSCREENING[psqno].PSQEDUCATION ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPDC ||
                    (
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINHEAD &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINFACE &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINNECK &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINSHOULDERS &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINCHEST &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINPAINARMS &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINWRISTS &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINHANDS &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINTRUNK &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINABDOMEN &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINLOWBACK &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINHIPS &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINGROIN &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINKNEES &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINANKLE &&
                        !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINFOOT
                    ) ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQDAYSMISSED ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINDURATION ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQRATEWORKHEAVY ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQRATEPAINWEEK ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQRATEPAIN3MONTH ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINOCCURENCES3MONTH ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQRATECOPETODECREASE ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQRATETENSION ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQRATEDEPRESSION ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQRATEPERMANENT ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQRATEBACKTOWORK ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQRATEJOBSATISFACTION ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPHYSICALPAINWORSE ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQPAINSTOPACTIVITY ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQNOTWORKWITHPAIN ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQLIGHTWORK1HR ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQWALK1HR ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQHOUSEHOLD ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQSHOPPING ||
                    !this.state.entities.notes.CWPAINSCREENING[psqno].PSQSLEEP
                ) {
                    this.errors.push({ section: 'Subjective', label: 'Pain Screening Questionnaire', to: 'subjective/sub_pain/subj_pain_psq' });
                }
            }

            // meds & supplements
            if (this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDTAKING === null ||
                this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDTAKING === undefined ||
                (this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDTAKING === true &&
                    (this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCURRENT === null ||
                        this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDCURRENT === undefined ||
                        !this.state.entities.notes.PTEVAL[this.pk].EVSUBMEDS
                    )
                )
            ) {
                this.errors.push({ section: 'Subjective', label: 'Medications & Supplements', to: 'subjective/subj_meds' });
            }

            // // screening
            // if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENNONE &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENDIPLOPIA &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENDYSPHAGIA &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENDYSARTHRIA &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENDROPATT &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENNIGHTPAIN &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENTINNITUS &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENATAXIA &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENNAUSEA &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENNUMBNESS &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENNYSTAGMUS &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENSWALLOW &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENWEIGHT &&
            //     !this.state.entities.notes.PTEVAL[this.pk].EVSUBSCREENDIZZY
            // ) {
            //     this.errors.push({ section: 'Subjective', label: 'Screening', to: 'subj_screen' });
            // }
            if (this.isWc) {

                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBSEVERITY) {
                    this.errors.push({ section: 'Subjective', label: 'Severity', to: 'subjective/sub_severity' });
                }
                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBMOTIVATION) {
                    this.errors.push({ section: 'Subjective', label: 'Motivation', to: 'subjective/sub_motivation' });
                }
                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBFITNESS) {
                    this.errors.push({ section: 'Subjective', label: 'Fitness', to: 'subjective/sub_fitness' });
                }
                if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBPHASE) {
                    this.errors.push({ section: 'Subjective', label: 'Phase', to: 'subjective/sub_phase' });
                }
            }

            // equipment
            if (this.state.entities.notes.PTEVAL[this.pk].EVSUBEQASSISTDEV &&
                !this.state.entities.notes.PTEVAL[this.pk].EVSUBEQASSISTDEVTXT) {
                this.errors.push({ section: 'Subjective', label: 'Equipment - Assistive Device Details', to: 'subjective/subj_equip' });
            }
            if (this.state.entities.notes.PTEVAL[this.pk].EVSUBEQORTHOSIS &&
                !this.state.entities.notes.PTEVAL[this.pk].EVSUBEQORTHOSISTXT) {
                this.errors.push({ section: 'Subjective', label: 'Equipment - Orthosis Details', to: 'subjective/subj_equip' });
            }



        } else {

            const onsetRaw = this.state.entities.notes.CPEPISODE[this.epno]?.EPDTONST;
            const treatmentRaw = this.state.entities.notes.PTEVAL[this.pk]?.NTTRTDATE;

            const result = OnSetTrtDtComp(onsetRaw, treatmentRaw);
            if (result) {
                this.errors.push({
                    section: 'Subjective',
                    label: 'History - Onset date should be less than or equal to Treatment date',
                    to: 'subjective/subj_history/subj_hist'
                });
            }
            let count = Object.keys(this.state.entities.notes.PTSUBJECTIVE)
                .filter(key => {
                    return (this.state.entities.notes.PTSUBJECTIVE[key].SUNTNO === this.pk &&
                        (
                            this.state.entities.notes.PTSUBJECTIVE[key].SUDETAILS === null
                        )
                    )
                }).length;

            if (count > 0) {
                this.errors.push({ section: 'Subjective', label: 'Complete subjective statements', to: 'subjective' });
            }

            count = Object.keys(this.state.entities.notes.PTSUBJECTIVE)
                .filter(key => {
                    return (this.state.entities.notes.PTSUBJECTIVE[key].SUNTNO === this.pk)
                }).length;

            if (count === 0 && this.noteType !== 3 && this.noteType !== 4) {
                this.errors.push({ section: 'Subjective', label: 'Subjective statement required', to: 'subjective' });
            }


            // work comp
            if (this.isWc) {
                if (!this.state.entities.notes.PTNOTE[this.pk].NTSUBWCSTATUS) {
                    this.errors.push({ section: 'Subjective', label: 'Work Comp - Status', to: 'subjective/subj_wc' });
                }

                if (this.state.entities.notes.PTNOTE[this.pk].NTSUBPAIN === null) {
                    this.errors.push({ section: 'Subjective', label: 'Pain Rating', to: 'subjective' });
                }
                if (this.noteType !== 2) {
                    if (!this.state.entities.notes.PTNOTE[this.pk].NTSUBWCDOLCURRENTLIFTFREQ ||
                        !this.state.entities.notes.PTNOTE[this.pk].NTSUBWCDOLCURRENTLIFT) {
                        this.errors.push({ section: 'Subjective', label: 'Work Comp - Current PDC', to: 'subjective/subj_wc/subj_wc_current_pdc' });
                    }
                }


            } else if (this.isPainRequired) {
                if (this.state.entities.notes.PTNOTE[this.pk].NTSUBPAIN === null) {
                    this.errors.push({ section: 'Subjective', label: 'Pain Rating', to: 'subjective' });
                }
            }

            let isPeds = this.state.entities.admissions[this.epno].isPeds;
            let isPedsSpeech = this.state.entities.admissions[this.epno].isPedsSpeech;

            if (isPeds && !isPedsSpeech && this.noteType !== 3 && this.noteType !== 4) {
                if (!this.state.entities.notes.PTNOTE[this.pk].NTINFOPLACEOFSERVICE) {
                    this.errors.push({ section: 'Subjective', label: 'Place of Service', to: 'subjective' });
                }
            }

        }

        function OnSetTrtDtComp(onsetRaw, treatmentRaw) {
            if (onsetRaw && treatmentRaw) {
                const onsetDate = new Date(onsetRaw);
                const treatmentDate = new Date(treatmentRaw);

                if (!isNaN(onsetDate) && !isNaN(treatmentDate)) {
                    const onsetStr = onsetDate.toISOString().split('T')[0];
                    const treatmentStr = treatmentDate.toISOString().split('T')[0];
                    return onsetStr > treatmentStr;
                }
            }
        }
    }

    static fillPDCErrors() {
        if (this.isWc) {
            if (!this.state.entities.notes.PTNOTE[this.pk].NTSUBWCDOLCURRENTLIFTFREQ ||
                !this.state.entities.notes.PTNOTE[this.pk].NTSUBWCDOLCURRENTLIFT) {
                this.errors.push({ section: 'Subjective', label: 'Work Comp - Current PDC', to: 'subjective/subj_wc/subj_wc_current_pdc' });
            }
        }
    }

    static fillObjectiveErrors() {
        let isPeds = this.state.entities.admissions[this.epno].isPeds;
        let isPedsEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
        let isSpeechEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
        let isSpeech = this.state.entities.admissions[this.epno].discipline === "ST" ? true : false;
        let isPedsSpeech = this.state.entities.admissions[this.epno].isPedsSpeech;

        let outRequired = true;

        if (this.noteType === 2 && ((isPeds && isPedsEnabled) || (isPedsSpeech && isSpeechEnabled))) {
            outRequired = false;
        }

        // must have at least one template selected
        let count = Object.keys(this.state.entities.notes.PTOBJECTIVETEMPLATESXREF)
            .filter(key => {
                return (this.noteType === 1 && this.state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBEVNO === this.pk) ||
                    (this.noteType !== 1 && this.state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBNTNO === this.pk)
            }).length;


        if (!isSpeech || !isSpeechEnabled) {
            // we only care if a template is missing on eval, PN and PN/DN
            if (count === 0 && (this.noteType === 1 || this.noteType === 3 || this.noteType === 5)) {
                this.errors.push({ section: 'Objective', label: 'Template required', to: 'objective' });
            }
        }

        if (this.noteType !== 4) {
            // outcome measures
            count = Object.keys(this.state.entities.notes.PTOUTMEASURES)
                .filter(key => {
                    return ((this.noteType === 1 && this.state.entities.notes.PTOUTMEASURES[key].OMEVNO === this.pk) ||
                        (this.noteType !== 1 && this.state.entities.notes.PTOUTMEASURES[key].OMNTNO === this.pk))
                }).length;

            if (count === 0 &&
                !this.state.entities.notes[this.table][this.pk][this.prefix + 'OBJNOOUTCOMEREASON'] && outRequired) {
                this.errors.push({ section: 'Objective', label: 'Outcome Measures', to: 'objective/obj_outmeasures' });
            }


            if (count > 0) {
                count = Object.keys(this.state.entities.notes.PTOUTMEASURES)
                    .filter(key => {
                        return (((this.noteType === 1 && this.state.entities.notes.PTOUTMEASURES[key].OMEVNO === this.pk) ||
                            (this.noteType !== 1 && this.state.entities.notes.PTOUTMEASURES[key].OMNTNO === this.pk)) &&
                            (!this.state.entities.notes.PTOUTMEASURES[key].OMNAME //if name is null
                                ||
                                (((this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== SPEECH_OUTCOME_CONSTANTS.GFTA_3 &&  //if not one of the "special peds"
                                    this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== SPEECH_OUTCOME_CONSTANTS.CELF_5 &&
                                    this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== SPEECH_OUTCOME_CONSTANTS.CELFP_2 &&
                                    this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== SPEECH_OUTCOME_CONSTANTS.CAAP_2 &&
                                    this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== SPEECH_OUTCOME_CONSTANTS.ROSSETTI_SCALE &&
                                    this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME !== 'Peabody (PDMS3)') || this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO === 47) &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMSCORE)
                                ||
                                (this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.GFTA_3 && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 && //if is GFTA_3
                                    (!this.state.entities.notes.PTOUTMEASURES[key].OMSOUNDINWORD || !this.state.entities.notes.PTOUTMEASURES[key].OMSOUNDINSENTENCE)
                                )
                                ||
                                ((this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.CELF_5 || this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.CELFP_2) && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 && //celf5 & 2
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMCORELANGSCORE
                                )
                                ||
                                (this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.CAAP_2 && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 &&
                                    (!this.state.entities.notes.PTOUTMEASURES[key].OMCONSTANTINV || !this.state.entities.notes.PTOUTMEASURES[key].OMPHONOPROCESS)
                                )
                                ||
                                (this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.ROSSETTI_SCALE && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 &&
                                    (!this.state.entities.notes.PTOUTMEASURES[key].OMEXPRESSIVELAND || !this.state.entities.notes.PTOUTMEASURES[key].OMRECEPTIVELANG)
                                )
                                ||
                                (this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === SPEECH_OUTCOME_CONSTANTS.isFcpR && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMSEVERITY
                                ) ||
                                (this.state.entities.notes.PTOUTMEASURES[key]?.OMNAME === 'Peabody (PDMS3)' && this.state.entities.notes.PTOUTMEASURES[key]?.OMMOUNO !== 47 &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMBODYCONTROLRAW &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMBODYTRANSRAW &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMOBJECTCONTROLRAW &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMHANDMANCONTROLRAW &&
                                    !this.state.entities.notes.PTOUTMEASURES[key].OMHANDEYECONTROLRAW
                                )
                            )
                        )
                    }).length;

                //need to check if the outcome is peds specific, and not using the OBJNOOUTCOMEREASON
                if (count > 0 &&
                    !this.state.entities.notes[this.table][this.pk][this.prefix + 'OBJNOOUTCOMEREASON'] && outRequired) {
                    this.errors.push({ section: 'Objective', label: 'Outcome Measures - required fields', to: 'objective/obj_outmeasures' });
                }

            }

            // Make sure any asterisk signs are complete
            if (this.noteType === 2 || this.noteType === 3 || this.noteType === 5) { // only DN and PN

                let count = Object.keys(this.state.entities.notes.PTOBJECTIVEASTERISKS)
                    .filter(key => {
                        return (this.state.entities.notes.PTOBJECTIVEASTERISKS[key].OANTNO === this.pk &&
                            (
                                this.state.entities.notes.PTOBJECTIVEASTERISKS[key].OAASTERISK === null ||
                                this.state.entities.notes.PTOBJECTIVEASTERISKS[key].OAPREINT === null ||
                                this.state.entities.notes.PTOBJECTIVEASTERISKS[key].OAPOSTINT === null
                            )
                        )
                    }).length;

                if (count > 0) {
                    this.errors.push({ section: 'Objective', label: 'Complete asterisk signs', to: 'objective/obj_asterisks' });
                }
            }
        }

        let opno = this.noteType === 1 ? Object.keys(this.state.entities.notes.PTOBJECTIVEPEDS)
            .find(key => (this.state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === this.pk))
            :
            Object.keys(this.state.entities.notes.PTOBJECTIVEPEDS)
                .find(key => (this.state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === this.pk));

        if (opno !== undefined) {
            if (this.state.entities.notes.PTOBJECTIVEPEDS[opno].OPPOSOTHER &&
                !this.state.entities.notes.PTOBJECTIVEPEDS[opno].OPPOSOTHERTXT && outRequired) {
                this.errors.push({ section: 'Objective', label: 'Observations - Posture other required', to: 'objective/obj_obs_posture' });
            }

            if (
                this.state.entities.notes.PTOBJECTIVEPEDS[opno].OPFINONINTZIPPER !== undefined &&
                this.state.entities.notes.PTOBJECTIVEPEDS[opno].OPFINONINTZIPPER !== null &&
                !this.state.entities.notes.PTOBJECTIVEPEDS[opno].OPFINONINTZIPPERSELF &&
                !this.state.entities.notes.PTOBJECTIVEPEDS[opno].OPFINONINTZIPPEROFF
            ) {
                this.errors.push({ section: 'Objective', label: 'Self or Off-Self is required', to: 'objective/obj_obs_finemotorpeds' });
            }
        }

    }


    static fillAlCategoryErrors(table, masterTable, prefix, timeColumn, to, sectionName, counts) {
        if (
            //// if one or more performed, must have total time
            (this.state.entities.notes[table] &&
                Object.keys(this.state.entities.notes[table])
                    .filter(key => this.state.entities.notes[table][key]['XL' + prefix + 'XLNO'] === this.xlno &&
                        this.state.entities.notes[table][key]['XL' + prefix + 'PERFORMED']).length > 0 &&
                !this.state.entities.notes.MLEXLOG[this.xlno][timeColumn]
            ) ||
            //// child - if performed, must have entry, activity, and sets/reps
            (this.state.entities.notes[table] &&
                Object.keys(this.state.entities.notes[table])
                    .filter(key => this.state.entities.notes[table][key]['XL' + prefix + 'XLNO'] === this.xlno &&
                        this.state.entities.notes[table][key]['XL' + prefix + 'PERFORMED'] &&
                        (
                            !this.state.entities.notes[table][key]['XL' + prefix + prefix + 'NO'] ||
                            !this.state.entities.notes[table][key]['XL' + prefix + 'ACTIVITY'] ||
                            !this.state.entities.notes[table][key]['XL' + prefix + 'SETSREPS']
                        )
                    ).length > 0)
        ) {
            this.errors.push({ section: 'Activity Log', label: sectionName + ' - required fields', to: to });
        }
        //// if therapist time is greater than total time, not valid
        if (this.state.entities.notes.MLEXLOG[this.xlno][timeColumn] && this.state.entities.notes.MLEXLOG[this.xlno][timeColumn + 'THERAPIST']
            && this.state.entities.notes.MLEXLOG[this.xlno][timeColumn + 'THERAPIST'] > this.state.entities.notes.MLEXLOG[this.xlno][timeColumn]) {
            this.errors.push({ section: 'Activity Log', label: sectionName + ' - invalid therapist/total times', to: to });
        }
        //// if dups exist across all cats, must remove one
        if (this.state.entities.notes[table] &&
            Object.keys(this.state.entities.notes[table])
                .filter(key => this.state.entities.notes[table][key]['XL' + prefix + 'XLNO'] === this.xlno &&
                    counts[this.getActivityName(this.state.entities.notes[table][key]['XL' + prefix + 'NO'], table, masterTable, prefix)] > 1).length > 0) {
            this.errors.push({ section: 'Activity Log', label: sectionName + ' - duplicate activity', to: to });
        }
    }

    static fillWpAlErrors() {
        let wp = Object.keys(this.state.entities.notes.MLWORKPROG)
            .filter(key => {
                return (this.state.entities.notes.MLWORKPROG[key].XLWPXLNO === this.xlno)
            });

        if (wp.length !== 0) {
            const hasNullPerformed = wp.every(key =>
                this.state.entities.notes.MLWORKPROG[key].XLWPPERFORMED === null
            );
            if (hasNullPerformed && (this.noteType !== 3 && this.noteType !== 4)) {
                this.errors.push({ section: 'Activity Log', label: 'Must have at least one item marked as "performed"', to: 'al/al_wp' });
            } else {

                if (this.noteType === 1 || this.noteType === 2 || this.noteType === 5 || this.noteType === 6) {
                    let startTime = this.state.entities.notes.MLEXLOG[this.xlno]['XLWORKPROGSTART'];
                    let endTime = this.state.entities.notes.MLEXLOG[this.xlno]['XLWORKPROGEND'];
                    let totalTime = this.state.entities.notes.MLEXLOG[this.xlno]['XLTIMEWORKPROG'];

                    if (startTime == null) {
                        this.errors.push({ section: 'Activity Log', label: 'Work Program Start Time - required field', to: 'al/al_wp' });
                    }
                    if (endTime == null) {
                        this.errors.push({ section: 'Activity Log', label: 'Work Program End Time - required field', to: 'al/al_wp' });
                    }
                    if (totalTime == null) {
                        this.errors.push({ section: 'Activity Log', label: 'Work Program Total Time - required field', to: 'al/al_wp' });
                    }
                    if (startTime && endTime && (endTime <= startTime)) {
                        this.errors.push({ section: 'Activity Log', label: 'WP - Start time must be less than end time', to: 'al/al_wp' });
                    }
                }
            }
        }

    }

    static fillAlErrors() {
        let evalCount = 0;
        let emptyEvalCount = 0;
        let activities = this.getAlActivities();
        var counts = {};
        for (var i = 0; i < activities.length; i++) {
            var act = activities[i];
            counts[act] = counts[act] ? counts[act] + 1 : 1;
        }

        let pocs = Object.keys(this.state.entities.notes.EVALCODES)
            .filter(key => {
                return (
                    (
                        (this.noteType === 1 && this.state.entities.notes.EVALCODES[key].RTEVNO === this.pk) ||
                        (this.noteType !== 1 && this.state.entities.notes.EVALCODES[key].RTNTNO === this.pk)
                    ) &&
                    this.state.entities.notes.EVALCODES[key].RTCODE.includes('POC')
                )
            })
            .map(key => this.state.entities.notes.EVALCODES[key].RTNO);

        // Eval
        //// if > 0 length, must have total time or if it is an eval document, must include at least one
        evalCount = Object.keys(this.state.entities.notes.MLEVAL)
            .filter(key => this.state.entities.notes.MLEVAL[key].XLEVXLNO === this.xlno &&
                this.state.entities.notes.MLEVAL[key].XLEVRTNO &&
                !pocs.includes(this.state.entities.notes.MLEVAL[key].XLEVRTNO))
            .map(key => this.state.entities.notes.MLEVAL[key]).length;

        emptyEvalCount = Object.keys(this.state.entities.notes.MLEVAL)
            .filter(key => this.state.entities.notes.MLEVAL[key].XLEVXLNO === this.xlno &&
                !this.state.entities.notes.MLEVAL[key].XLEVRTNO)
            .map(key => this.state.entities.notes.MLEVAL[key]).length;

        if (((evalCount > 0 && !this.state.entities.notes.MLEXLOG[this.xlno].XLTIMEEVAL) || emptyEvalCount > 0)) {
            this.errors.push({ section: 'Activity Log', label: 'Evals - required fields', to: 'al/al_evals' });
        }

        if (this.noteType === 1 && evalCount === 0) {
            if (!this.state.entities.notes.PTEVAL[this.pk].EVNOCHARGEREASON) {
                this.errors.push({ section: 'Activity Log', label: 'Evals - One Required', to: 'al/al_evals' });
            }
        }


        this.fillAlCategoryErrors('MLTHERACT', 'MLMASTERTHERACT', 'TA', 'XLTIMETHERACT', 'al/al_theract', 'Therapeutic Activities', counts);
        this.fillAlCategoryErrors('MLSELFCARE', 'MLMASTERSELFCARE', 'SC', 'XLTIMESELFCARE', 'al/al_selfcare', 'Self-Care', counts);
        this.fillAlCategoryErrors('MLNEURO', 'MLMASTERNEURO', 'NE', 'XLTIMENEURO', 'al/al_neuro', 'Neuromuscular Re-Ed', counts);
        this.fillAlCategoryErrors('MLTHEREX', 'MLMASTERTHEREX', 'TE', 'XLTIMETHEREX', 'al/al_therex', 'Therapeutic Exercise', counts);
        this.fillAlCategoryErrors('MLMANUAL', 'MLMASTERMANUAL', 'MA', 'XLTIMEMANUAL', 'al/al_manual', 'Manual Therapy', counts);

        // Speech
        if (
            //// if one or more performed, must have total time
            (this.state.entities.notes.MLSPEECH &&
                Object.keys(this.state.entities.notes.MLSPEECH)
                    .filter(key => this.state.entities.notes.MLSPEECH[key].XLSPXLNO === this.xlno &&
                        this.state.entities.notes.MLSPEECH[key].XLSPPERFORMED).length > 0 &&
                !this.state.entities.notes.MLEXLOG[this.xlno].XLTIMESPEECH
            ) ||
            //// child - if performed, must have XLSPACTIVITY
            (this.state.entities.notes.MLSPEECH &&
                Object.keys(this.state.entities.notes.MLSPEECH)
                    .filter(key => this.state.entities.notes.MLSPEECH[key].XLSPXLNO === this.xlno &&
                        this.state.entities.notes.MLSPEECH[key].XLSPPERFORMED &&
                        (
                            !this.state.entities.notes.MLSPEECH[key].XLSPACTIVITY
                        )
                    ).length > 0)
        ) {
            this.errors.push({ section: 'Activity Log', label: 'Speech - required fields', to: 'al/al_speech' });
        }
        //// if therapist time is greater than total time, not valid
        if (this.state.entities.notes.MLEXLOG[this.xlno].XLTIMESPEECH && this.state.entities.notes.MLEXLOG[this.xlno].XLTIMESPEECHTHERAPIST
            && this.state.entities.notes.MLEXLOG[this.xlno].XLTIMESPEECHTHERAPIST > this.state.entities.notes.MLEXLOG[this.xlno].XLTIMESPEECH) {
            this.errors.push({ section: 'Activity Log', label: 'Speech - invalid therapist/total times', to: 'al/al_speech' });
        }
        //// if dups exist across all cats, must remove one
        if (this.state.entities.notes.MLSPEECH &&
            Object.keys(this.state.entities.notes.MLSPEECH)
                .filter(key => this.state.entities.notes.MLSPEECH[key].XLSPXLNO === this.xlno &&
                    counts[this.getSpeechName(this.state.entities.notes.MLSPEECH[key].XLSPNO)] > 1).length > 0) {
            this.errors.push({ section: 'Activity Log', label: 'Speech - duplicate activity', to: 'al/al_speech' });
        }

        // Gait
        if (
            //// if one or more performed, must have total time
            (this.state.entities.notes.MLGAIT &&
                Object.keys(this.state.entities.notes.MLGAIT)
                    .filter(key => this.state.entities.notes.MLGAIT[key].XLGAXLNO === this.xlno &&
                        this.state.entities.notes.MLGAIT[key].XLGAPERFORMED).length > 0 &&
                !this.state.entities.notes.MLEXLOG[this.xlno].XLTIMEGAIT
            ) ||
            //// child - if performed, must have XLGAACTIVITY, XLGADISTTIME
            (this.state.entities.notes.MLGAIT &&
                Object.keys(this.state.entities.notes.MLGAIT)
                    .filter(key => this.state.entities.notes.MLGAIT[key].XLGAXLNO === this.xlno &&
                        this.state.entities.notes.MLGAIT[key].XLGAPERFORMED &&
                        (
                            !this.state.entities.notes.MLGAIT[key].XLGAACTIVITY ||
                            !this.state.entities.notes.MLGAIT[key].XLGADISTTIME
                        )
                    ).length > 0)
        ) {
            this.errors.push({ section: 'Activity Log', label: 'Gait - required fields', to: 'al/al_gait' });
        }
        //// if therapist time is greater than total time, not valid
        if (this.state.entities.notes.MLEXLOG[this.xlno].XLTIMEGAIT && this.state.entities.notes.MLEXLOG[this.xlno].XLTIMEGAITTHERAPIST
            && this.state.entities.notes.MLEXLOG[this.xlno].XLTIMEGAITTHERAPIST > this.state.entities.notes.MLEXLOG[this.xlno].XLTIMEGAIT) {
            this.errors.push({ section: 'Activity Log', label: 'Gait - invalid therapist/total times', to: 'al/al_gait' });
        }
        //// if dups exist across all cats, must remove one
        if (this.state.entities.notes.MLGAIT &&
            Object.keys(this.state.entities.notes.MLGAIT)
                .filter(key => this.state.entities.notes.MLGAIT[key].XLGAXLNO === this.xlno &&
                    counts[this.getGaitName(this.state.entities.notes.MLGAIT[key].XLGANO)] > 1).length > 0) {
            this.errors.push({ section: 'Activity Log', label: 'Gait - duplicate activity', to: 'al/al_gait' });
        }

        // Aqua
        if (
            //// if one or more performed, must have total time
            (this.state.entities.notes.MLAQUATICS &&
                Object.keys(this.state.entities.notes.MLAQUATICS)
                    .filter(key => this.state.entities.notes.MLAQUATICS[key].XLAQXLNO === this.xlno &&
                        this.state.entities.notes.MLAQUATICS[key].XLAQPERFORMED).length > 0 &&
                !this.state.entities.notes.MLEXLOG[this.xlno].XLTIMEAQUA
            ) ||
            //// child - if performed, must have XLAQAQNO, XLAQACTIVITY, XLAQSETSREPS
            (this.state.entities.notes.MLAQUATICS &&
                Object.keys(this.state.entities.notes.MLAQUATICS)
                    .filter(key => this.state.entities.notes.MLAQUATICS[key].XLAQXLNO === this.xlno &&
                        this.state.entities.notes.MLAQUATICS[key].XLAQPERFORMED &&
                        (
                            !this.state.entities.notes.MLAQUATICS[key].XLAQAQNO ||
                            !this.state.entities.notes.MLAQUATICS[key].XLAQACTIVITY ||
                            !this.state.entities.notes.MLAQUATICS[key].XLAQSETSREPS
                        )
                    ).length > 0)
        ) {
            this.errors.push({ section: 'Activity Log', label: 'Aquatics - required fields', to: 'al/al_aqua' });
        }
        //// if therapist time is greater than total time, not valid
        if (this.state.entities.notes.MLEXLOG[this.xlno].XLTIMEAQUA && this.state.entities.notes.MLEXLOG[this.xlno].XLTIMEAQUATHERAPIST
            && this.state.entities.notes.MLEXLOG[this.xlno].XLTIMEAQUATHERAPIST > this.state.entities.notes.MLEXLOG[this.xlno].XLTIMEAQUA) {
            this.errors.push({ section: 'Activity Log', label: 'Aquatics - invalid therapist/total times', to: 'al/al_aqua' });
        }
        //// if dups exist across all cats, must remove one
        if (this.state.entities.notes.MLAQUATICS &&
            Object.keys(this.state.entities.notes.MLAQUATICS)
                .filter(key => this.state.entities.notes.MLAQUATICS[key].XLAQXLNO === this.xlno &&
                    counts[this.getAquaticsName(this.state.entities.notes.MLAQUATICS[key].XLAQNO)] > 1).length > 0) {
            this.errors.push({ section: 'Activity Log', label: 'Aquatics - duplicate activity', to: 'al/al_aqua' });
        }

        // Modalities
        //// child - if performed, must have XLMDMDNO, XLMDACTIVITIY, XLMDTIME
        if (this.state.entities.notes.MLMODALITIES) {
            if (Object.keys(this.state.entities.notes.MLMODALITIES)
                .filter(key => this.state.entities.notes.MLMODALITIES[key].XLMDXLNO === this.xlno &&
                    this.state.entities.notes.MLMODALITIES[key].XLMDPERFORMED &&
                    (
                        !this.state.entities.notes.MLMODALITIES[key].XLMDMDNO ||
                        !this.state.entities.notes.MLMODALITIES[key].XLMDACTIVITY ||
                        !this.state.entities.notes.MLMODALITIES[key].XLMDTIME
                    )
                ).length > 0
            ) {
                this.errors.push({ section: 'Activity Log', label: 'Modalities - required fields', to: 'al/al_mod' });
            }
            //// No pending codes
            if (Object.keys(this.state.entities.notes.MLMODALITIES)
                .filter(key => {
                    return (this.state.entities.notes.MLMODALITIES[key].XLMDXLNO === this.xlno &&
                        this.state.entities.notes.MLMODALITIES[key].XLMDPENDING === true)
                }).length > 0) {
                this.errors.push({ section: 'Activity Log', label: 'Modalities - confirm non-covered treatment', to: 'al/al_mod' });
            }
        }
        // Other
        //// child - if performed and group - must have XLOETIME
        //// child - if performed and not group - must have XLOEOENO, XLOEACTIVITY, XLOETIME
        if (this.state.entities.notes.MLOTHER) {
            if (Object.keys(this.state.entities.notes.MLOTHER)
                .filter(key => this.state.entities.notes.MLOTHER[key].XLOEXLNO === this.xlno &&
                    this.state.entities.notes.MLOTHER[key].XLOEPERFORMED &&
                    (
                        (
                            this.state.entities.notes.MLOTHER[key].XLOEOENO === 14 &&
                            !this.state.entities.notes.MLOTHER[key].XLOETIME
                        )
                        ||
                        (
                            this.state.entities.notes.MLOTHER[key].XLOEOENO !== 14 &&
                            (
                                !this.state.entities.notes.MLOTHER[key].XLOEOENO ||
                                !this.state.entities.notes.MLOTHER[key].XLOEACTIVITY ||
                                !this.state.entities.notes.MLOTHER[key].XLOETIME
                            )
                        )
                    )
                ).length > 0
            ) {
                this.errors.push({ section: 'Activity Log', label: 'Other - required fields', to: 'al/al_other' });
            }
            //// Only one 97150
            if (Object.keys(this.state.entities.notes.MLOTHER)
                .filter(key => {
                    return (this.state.entities.notes.MLOTHER[key].XLOEXLNO === this.xlno &&
                        this.state.entities.notes.MLOTHER[key].XLOEPERFORMED === true &&
                        Object.keys(this.state.entities.masterData.MLMASTEROTHER)
                            .find(x => this.state.entities.masterData.MLMASTEROTHER[x].OENO === this.state.entities.notes.MLOTHER[key].XLOEOENO &&
                                this.state.entities.masterData.MLMASTEROTHER[x].OECODE === '97150'
                            ) !== undefined
                    )
                }).length > 1) {
                this.errors.push({ section: 'Activity Log', label: 'Other - duplicate group therapy', to: 'al/al_other' });
            }
            //// No pending codes
            if (Object.keys(this.state.entities.notes.MLOTHER)
                .filter(key => {
                    return (this.state.entities.notes.MLOTHER[key].XLOEXLNO === this.xlno &&
                        this.state.entities.notes.MLOTHER[key].XLOEPENDING === true)
                }).length > 0) {
                this.errors.push({ section: 'Activity Log', label: 'Other - confirm non-covered treatment', to: 'al/al_other' });
            }
        }

        // PhysPerfTest
        if (this.state.entities.notes.MLSPECIALTYTESTS) {
            //// child - if performed, must have XLSZMDNO, XLSZACTIVITY, XLSZTIME
            if (Object.keys(this.state.entities.notes.MLSPECIALTYTESTS)
                .filter(key => this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZXLNO === this.xlno &&
                    this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZPERFORMED &&
                    (
                        !this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZMDNO ||
                        !this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZACTIVITY ||
                        !this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZTIME
                    )
                ).length > 0
            ) {
                this.errors.push({ section: 'Activity Log', label: 'Physical Performance Test or Measurement - required fields', to: 'al/al_ppt' });
            }
            //// if dups exist across all cats, must remove one
            if (Object.keys(this.state.entities.notes.MLSPECIALTYTESTS)
                .filter(key => this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZXLNO === this.xlno &&
                    counts[this.getSpecialtyTestName(this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZNO)] > 1).length > 0) {
                this.errors.push({ section: 'Activity Log', label: 'Physical Performance Test or Measurement - duplicate activity', to: 'al/al_ppt' });
            }
            //// No pending codes
            if (Object.keys(this.state.entities.notes.MLSPECIALTYTESTS)
                .filter(key => {
                    return (this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZXLNO === this.xlno &&
                        this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZPENDING === true)
                }).length > 0) {
                this.errors.push({ section: 'Activity Log', label: 'Physical Performance Test or Measurement - confirm non-covered treatment', to: 'al/al_ppt' });
            }

        }
    }

    static getAlActivities() {
        let activities = [];
        // TherAct
        activities = activities.concat(Object.keys(this.state.entities.notes.MLTHERACT)
            .filter(key => this.state.entities.notes.MLTHERACT[key].XLTAXLNO === this.xlno &&
                (
                    this.state.entities.notes.MLTHERACT[key].XLTAACTIVITY ||
                    this.state.entities.notes.MLTHERACT[key].XLTATANO
                )
            )
            .map(key => {
                return this.getActivityName(this.state.entities.notes.MLTHERACT[key].XLTANO, 'MLTHERACT', 'MLMASTERTHERACT', 'TA');
            }));

        // SelfCare
        activities = activities.concat(Object.keys(this.state.entities.notes.MLSELFCARE)
            .filter(key => this.state.entities.notes.MLSELFCARE[key].XLSCXLNO === this.xlno &&
                (
                    this.state.entities.notes.MLSELFCARE[key].XLSCACTIVITY ||
                    this.state.entities.notes.MLSELFCARE[key].XLSCSCNO
                )
            )
            .map(key => {
                return this.getActivityName(this.state.entities.notes.MLSELFCARE[key].XLSCNO, 'MLSELFCARE', 'MLMASTERSELFCARE', 'SC');
            }));

        // Neuro
        activities = activities.concat(Object.keys(this.state.entities.notes.MLNEURO)
            .filter(key => this.state.entities.notes.MLNEURO[key].XLNEXLNO === this.xlno &&
                (
                    this.state.entities.notes.MLNEURO[key].XLNEACTIVITY ||
                    this.state.entities.notes.MLNEURO[key].XLNENENO
                )
            )
            .map(key => {
                return this.getActivityName(this.state.entities.notes.MLNEURO[key].XLNENO, 'MLNEURO', 'MLMASTERNEURO', 'SC');
            }));

        // TherEx
        activities = activities.concat(Object.keys(this.state.entities.notes.MLTHEREX)
            .filter(key => this.state.entities.notes.MLTHEREX[key].XLTEXLNO === this.xlno &&
                (
                    this.state.entities.notes.MLTHEREX[key].XLTEACTIVITY ||
                    this.state.entities.notes.MLTHEREX[key].XLTETENO
                )
            )
            .map(key => {
                return this.getActivityName(this.state.entities.notes.MLTHEREX[key].XLTENO, 'MLTHEREX', 'MLMASTERTHEREX', 'TE');
            }));

        // Manual
        activities = activities.concat(Object.keys(this.state.entities.notes.MLMANUAL)
            .filter(key => this.state.entities.notes.MLMANUAL[key].XLMAXLNO === this.xlno &&
                (
                    this.state.entities.notes.MLMANUAL[key].XLMAACTIVITY ||
                    this.state.entities.notes.MLMANUAL[key].XLMAMANO
                )
            )
            .map(key => {
                return this.getActivityName(this.state.entities.notes.MLMANUAL[key].XLMANO, 'MLMANUAL', 'MLMASTERMANUAL', 'MA');
            }));

        // Gait
        activities = activities.concat(Object.keys(this.state.entities.notes.MLGAIT)
            .filter(key => this.state.entities.notes.MLGAIT[key].XLGAXLNO === this.xlno &&
                (
                    this.state.entities.notes.MLGAIT[key].XLGAACTIVITY ||
                    this.state.entities.notes.MLGAIT[key].XLGAGANO ||
                    this.state.entities.notes.MLGAIT[key].XLGAGLNO ||
                    this.state.entities.notes.MLGAIT[key].XLGAGSNO
                )
            )
            .map(key => {
                return this.getGaitName(this.state.entities.notes.MLGAIT[key].XLGANO);
            }));

        // Aqua
        activities = activities.concat(Object.keys(this.state.entities.notes.MLAQUATICS)
            .filter(key => this.state.entities.notes.MLAQUATICS[key].XLAQXLNO === this.xlno &&
                (
                    this.state.entities.notes.MLAQUATICS[key].XLAQACTIVITY ||
                    this.state.entities.notes.MLAQUATICS[key].XLAQAQNO
                )
            )
            .map(key => {
                return this.getAquaticsName(this.state.entities.notes.MLAQUATICS[key].XLAQNO);
            }));

        // PhysPerfTest
        activities = activities.concat(Object.keys(this.state.entities.notes.MLSPECIALTYTESTS)
            .filter(key => this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZXLNO === this.xlno &&
                (
                    this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZACTIVITY ||
                    this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZMDNO
                )
            )
            .map(key => {
                return this.getSpecialtyTestName(this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZNO);
            }));

        return activities;
    }

    static getActivityName(pk, table, masterTable, prefix) {
        let entry = this.state.entities.notes[table][pk];
        let tmp = this.state.entities.masterData[masterTable][
            Object.keys(this.state.entities.masterData[masterTable])
                .find(x => (this.state.entities.masterData[masterTable][x][prefix + 'NO'] === entry['XL' + prefix + prefix + 'NO']))
        ];
        let act = entry['XL' + prefix + 'ACTIVITY'] ? entry['XL' + prefix + 'ACTIVITY'] : 'no name';
        return act + ' ' + (tmp ? tmp[prefix + 'NAME'] : 'no name');
    }

    static getGaitName(xlgano) {
        let tmp1 = this.state.entities.masterData.MLMASTERGAITASSDEV[
            Object.keys(this.state.entities.masterData.MLMASTERGAITASSDEV)
                .find(x => (this.state.entities.masterData.MLMASTERGAITASSDEV[x].GANO === this.state.entities.notes.MLGAIT[xlgano].XLGAGANO))
        ];
        let tmp2 = this.state.entities.masterData.MLMASTERGAITLEVASS[
            Object.keys(this.state.entities.masterData.MLMASTERGAITLEVASS)
                .find(x => (this.state.entities.masterData.MLMASTERGAITLEVASS[x].GLNO === this.state.entities.notes.MLGAIT[xlgano].XLGAGLNO))
        ];
        let tmp3 = this.state.entities.masterData.MLMASTERGAITSURFACE[
            Object.keys(this.state.entities.masterData.MLMASTERGAITSURFACE)
                .find(x => (this.state.entities.masterData.MLMASTERGAITSURFACE[x].GSNO === this.state.entities.notes.MLGAIT[xlgano].XLGAGSNO))
        ];
        let act = this.state.entities.notes.MLGAIT[xlgano].XLGAACTIVITY ? this.state.entities.notes.MLGAIT[xlgano].XLGAACTIVITY : 'no name';
        return act + ' ' + (tmp1 ? tmp1.GANAME : 'no name') + ' ' + (tmp2 ? tmp2.GLNAME : 'no name') + ' ' + (tmp3 ? tmp3.GSNAME : 'no name');
    }

    static getSpeechName(xlaqno) {
        let tmp = this.state.entities.masterData.MLMASTERSPEECH[
            Object.keys(this.state.entities.masterData.MLMASTERSPEECH)
                .find(x => (this.state.entities.masterData.MLMASTERSPEECH[x].SPNO === this.state.entities.notes.MLSPEECH[xlaqno]?.XLSPSPNO))
        ];
        let act = this.state.entities.notes.MLSPEECH[xlaqno].XLSPACTIVITY ? this.state.entities.notes.MLSPEECH[xlaqno].XLSPACTIVITY : 'no name';
        return (tmp ? tmp.SPNAME : 'no name') + ' ' + act;
    }

    static getAquaticsName(xlaqno) {
        let tmp = this.state.entities.masterData.MLMASTERAQUATICS[
            Object.keys(this.state.entities.masterData.MLMASTERAQUATICS)
                .find(x => (this.state.entities.masterData.MLMASTERAQUATICS[x].AQNO === this.state.entities.notes.MLAQUATICS[xlaqno].XLAQAQNO))
        ];
        let act = this.state.entities.notes.MLAQUATICS[xlaqno].XLAQACTIVITY ? this.state.entities.notes.MLAQUATICS[xlaqno].XLAQACTIVITY : 'no name';
        return (tmp ? tmp.AQNAME : 'no name') + ' ' + act;
    }

    static getSpecialtyTestName(xlszno) {
        let tmp = this.state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[
            Object.keys(this.state.entities.masterData.MLMASTERSTANDARDIZEDTESTS)
                .find(x => (this.state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[x].SZNO === this.state.entities.notes.MLSPECIALTYTESTS[xlszno].XLSZMDNO))
        ];
        let act = this.state.entities.notes.MLSPECIALTYTESTS[xlszno].XLSZACTIVITY ? this.state.entities.notes.MLSPECIALTYTESTS[xlszno].XLSZACTIVITY : 'no name';
        return act + ' ' + (tmp ? tmp.SZNAME : 'no name');
    }

    static fillGoalErrors() {
        let customGoalId = parseInt(this.state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE);
        let freeFormGoalId = parseInt(this.state.entities.masterData.PROPS['PTERO_FREE_FORM_GOAL_ID'].PRVALUE);
        let indHepGoalId = parseInt(this.state.entities.masterData.PROPS['PTERO_IND_HEP_GOAL_ID'].PRVALUE);

        if (this.state.entities.notes.PTGOALS) {
            Object.keys(this.state.entities.notes.PTGOALS)
                .filter(key => {
                    return ((this.state.entities.notes.PTGOALS[key].GOEVNO === this.pk && this.noteType === 1) || (this.state.entities.notes.PTGOALS[key].GONTNO === this.pk && this.noteType !== 1)) &&
                        this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                        this.state.entities.notes.PTGOALS[key].GOMGNO === indHepGoalId &&
                        (!this.state.entities.notes.PTGOALS[key].GODATE ||
                            (this.noteType !== 1 && !this.state.entities.notes.PTGOALS[key].GOGPNO)
                        )
                })
                .forEach(key => {
                    this.errors.push({ section: 'Goals', label: 'Independence with Home Program', to: 'goals/ind_hep_' + key });
                });
        }


        // EVAL 
        if (this.noteType === 1) {
            // Must have at least one goal on eval UNLESS it’s “Eval Only” and no treatment (charge other than eval/PPOC) was performed.
            let goalCount = Object.keys(this.state.entities.notes.PTGOALS)
                .filter(key => {
                    return (this.state.entities.notes.PTGOALS[key].GOEVNO === this.pk)
                        && this.state.entities.notes.PTGOALS[key].GODELETED !== true
                })
                .length;

            let stgCount = Object.keys(this.state.entities.notes.PTSHORTGOALS)
                .filter(key => {
                    return (this.state.entities.notes.PTSHORTGOALS[key]?.SGEVNO === this.pk && //PK MATCH
                        this.state.entities.notes.PTSHORTGOALS[key].SGACTIVE) //STG is active
                })
                .length;

            if (goalCount === 0) {
                if (Object.keys(this.state.entities.notes.PTPLAN)
                    .find(x => (this.state.entities.notes.PTPLAN[x].PLEVNO === this.pk && !this.state.entities.notes.PTPLAN[x].PLEVALONLY))) {
                    // must have at least one thing on the plan (other than eval only)
                    this.errors.push({ section: 'Goals', label: 'One Required', to: 'goals' });
                }
            }

            let isCwsOrigin = this.noteType !== 1 && this.state.entities.notes.PTNOTE[this.pk].NTMNNO !== null ? true : false;

            if (stgCount === 0 && !isCwsOrigin) {
                if (Object.keys(this.state.entities.notes.PTPLAN)
                    .find(x => (this.state.entities.notes.PTPLAN[x].PLEVNO === this.pk && !this.state.entities.notes.PTPLAN[x].PLEVALONLY))) {
                    // must have at least one thing on the plan (other than eval only)
                    this.errors.push({ section: 'Short Term Goals', label: 'One Required', to: 'goals' });
                }
            }

            if (this.isWc) { // WC Goal Validations
                let masterLifts = [158, 159, 160, 161, 162, 163, 164, 165, 166, 195, 196, 197];
                let masterPushs = [170, 171, 172, 173, 174, 175, 176, 177, 178];
                let liftCount = Object.keys(this.state.entities.notes.PTGOALS)
                    .filter(key => {
                        return (this.state.entities.notes.PTGOALS[key].GOEVNO === this.pk
                            && this.state.entities.notes.PTGOALS[key].GODELETED !== true
                            && masterLifts.includes(this.state.entities.notes.PTGOALS[key].GOMGNO))
                    })
                    .length;
                // WC - must have a lift/carry goal
                if (liftCount === 0) {
                    this.errors.push({ section: 'Goals', label: 'Lift/Carry Goal Required', to: 'goals' });
                }
                if (this.state.entities.notes.PTGOALS) {
                    Object.keys(this.state.entities.notes.PTGOALS)
                        .filter(key => {
                            if (
                                this.state.entities.notes.PTGOALS[key].GOEVNO === this.pk &&
                                this.state.entities.notes.PTGOALS[key].GODELETED !== true
                            ) {
                                return true;
                            }
                            return false;
                        })
                        .forEach(key => {
                            let goal = this.state.entities.notes.PTGOALS[key];
                            let goalName = goal.GOMGNO ? this.state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                            if (goal.GOMGNO === 167) {
                                goalName = goal.GOCUSTOM ? goal.GOCUSTOM : '<Custom Activity>';
                            }
                            if (masterLifts.includes(goal.GOMGNO)) { // lifting
                                if (!goal.GODATE ||
                                    !goal.GOCLOF ||
                                    !goal.GOPLOF ||
                                    !goal.GOOBJECTIVE ||
                                    !goal.GOOBJECTIVE) {
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            } else if (masterPushs.includes(goal.GOMGNO)) { // pushing
                                if (!goal.GODATE ||
                                    !goal.GOCLOF ||
                                    !goal.GOPLOF ||
                                    !goal.GOOBJECTIVE ||
                                    !goal.GOOBJECTIVE) {
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            } else if (goal.GOMGNO === indHepGoalId) {
                            } else {
                                // WC Goals - must have Activity, Goal Level, Work Task, Date, CLOF, Desc
                                if (!goal.GOMGNO ||
                                    !goal.GOGOALLEVEL ||
                                    !goal.GODATE ||
                                    !goal.GOCLOF ||
                                    !goal.GOOBJECTIVE) {
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            }
                        });
                }
            } else { // Functional Goal Validations
                // Functional Goals - must have Activity, Goal Level, Objective, Date, PLOF, CLOF
                let isPeds = this.state.entities.admissions[this.epno].isPeds;
                let isPedsEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;


                let isPedsSpeech = this.state.entities.admissions[this.epno].isPedsSpeech;
                let isSpeechEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;

                if ((isPeds && isPedsEnabled) || (isPedsSpeech && isSpeechEnabled)) {
                    if (this.state.entities.notes.PTGOALS) {
                        Object.keys(this.state.entities.notes.PTGOALS)
                            .filter(key => {
                                if (
                                    this.state.entities.notes.PTGOALS[key].GOEVNO === this.pk &&
                                    this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                                    (
                                        !this.state.entities.notes.PTGOALS[key].GOMGNO ||
                                        (this.state.entities.notes.PTGOALS[key].GOMGNO === customGoalId && !this.state.entities.notes.PTGOALS[key].GOCUSTOM) ||
                                        !this.state.entities.notes.PTGOALS[key].GODATE ||
                                        !this.state.entities.notes.PTGOALS[key].GOOBJECTIVE ||
                                        !this.state.entities.notes.PTGOALS[key].GOCURRENTDESC ||
                                        !this.state.entities.notes.PTGOALS[key].GOLONOCURRENT ||
                                        !this.state.entities.notes.PTGOALS[key].GOLONOGOAL

                                    )
                                ) {
                                    return true;
                                }
                                return false;
                            })
                            .forEach(key => {
                                let goal = this.state.entities.notes.PTGOALS[key];
                                let goalName = goal.GOMGNO && goal.GOMGNO !== customGoalId ? this.state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                                if (goal.GOMGNO === indHepGoalId) {
                                } else {
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            });
                    }
                }
                else {
                    if (this.state.entities.notes.PTGOALS) {
                        Object.keys(this.state.entities.notes.PTGOALS)
                            .filter(key => {
                                if (
                                    this.state.entities.notes.PTGOALS[key].GOEVNO === this.pk &&
                                    this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                                    (
                                        !this.state.entities.notes.PTGOALS[key].GOMGNO ||
                                        (this.state.entities.notes.PTGOALS[key].GOMGNO === customGoalId && !this.state.entities.notes.PTGOALS[key].GOCUSTOM) ||
                                        !this.state.entities.notes.PTGOALS[key].GOGOALLEVEL ||
                                        !this.state.entities.notes.PTGOALS[key].GODATE ||
                                        !this.state.entities.notes.PTGOALS[key].GOPLOF ||
                                        !this.state.entities.notes.PTGOALS[key].GOCLOF ||
                                        !this.state.entities.notes.PTGOALS[key].GOOBJECTIVE
                                    )
                                ) {
                                    return true;
                                }
                                return false;
                            })
                            .forEach(key => {
                                let goal = this.state.entities.notes.PTGOALS[key];
                                let goalName = goal.GOMGNO && goal.GOMGNO !== customGoalId ? this.state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                                if (goal.GOMGNO === indHepGoalId) {
                                } else {
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            });
                    }
                }
            }

            if (this.state.entities.notes.PTSHORTGOALS) {
                Object.keys(this.state.entities.notes.PTSHORTGOALS)
                    .filter(key => {
                        if (this.state.entities.notes.PTSHORTGOALS[key]?.SGEVNO === this.pk && //PK MATCH
                            this.state.entities.notes.PTSHORTGOALS[key].SGACTIVE && //STG is active
                            (
                                !this.state.entities.notes.PTSHORTGOALS[key].SGDESC || //description is empty
                                !this.state.entities.notes.PTSHORTGOALS[key].SGDATE //date is empty
                            )
                        ) {
                            return true;
                        }
                        return false;
                    })
                    .forEach(key => {
                        let stGoalName = this.state.entities.notes.PTSHORTGOALS[key].SGNAME ?? (this.state.entities.notes.PTSHORTGOALS[key].SGDESC ?? '<Custom Short Term Goal Not Defined>')
                        this.errors.push({ section: 'Goals', label: stGoalName, to: 'goals/sgno_' + this.state.entities.notes.PTSHORTGOALS[key].SGNO });
                    });
            }

        }
        // DN
        if (this.noteType === 2) {

            let isPeds = this.state.entities.admissions[this.epno].isPeds;
            let isPedsEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;

            let isPedsSpeech = this.state.entities.admissions[this.epno].isPedsSpeech;
            let isSpeechEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;

            if ((isPeds && isPedsEnabled) || (isPedsSpeech && isSpeechEnabled)) {
                if (this.state.entities.notes.PTGOALS) {
                    Object.keys(this.state.entities.notes.PTGOALS)
                        .filter(key => {
                            if (
                                this.state.entities.notes.PTGOALS[key].GOEVNO === this.pk &&
                                this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                                (
                                    !this.state.entities.notes.PTGOALS[key].GOMGNO ||
                                    (this.state.entities.notes.PTGOALS[key].GOMGNO === customGoalId && !this.state.entities.notes.PTGOALS[key].GOCUSTOM) ||
                                    !this.state.entities.notes.PTGOALS[key].GODATE ||
                                    !this.state.entities.notes.PTGOALS[key].GOOBJECTIVE ||
                                    !this.state.entities.notes.PTGOALS[key].GOCURRENTDESC ||
                                    !this.state.entities.notes.PTGOALS[key].GOLONOCURRENT ||
                                    !this.state.entities.notes.PTGOALS[key].GOLONOGOAL

                                )
                            ) {
                                return true;
                            }
                            return false;
                        })
                        .forEach(key => {
                            let goal = this.state.entities.notes.PTGOALS[key];
                            let goalName = goal.GOMGNO && goal.GOMGNO !== customGoalId ? this.state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                            if (goal.GOMGNO === indHepGoalId) {
                            } else {
                                this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                            }
                        });
                }
            }
            else {


                Object.keys(this.state.entities.notes.PTGOALS)
                    .filter(key => {
                        if (
                            this.state.entities.notes.PTGOALS[key].GONTNO === this.pk &&
                            this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                            (
                                (this.state.entities.notes.PTGOALS[key].GOMGNO !== freeFormGoalId &&
                                    this.state.entities.notes.PTGOALS[key].GOMGNO !== indHepGoalId &&
                                    (
                                        !this.state.entities.notes.PTGOALS[key].GOCLOF ||
                                        !this.state.entities.notes.PTGOALS[key].GOGPNO ||
                                        !this.state.entities.notes.PTGOALS[key].GODATE
                                    )
                                )
                                ||
                                (this.state.entities.notes.PTGOALS[key].GOMGNO === freeFormGoalId &&
                                    (
                                        !this.state.entities.notes.PTGOALS[key].GOGPNO
                                    )
                                )
                                ||
                                (!this.state.entities.notes.PTGOALS[key].GOGPNO)
                            )
                        ) {
                            return true;
                        }
                        return false;
                    })
                    .forEach(key => {

                        let goal = this.state.entities.notes.PTGOALS[key];
                        if (goal.GOMGNO === indHepGoalId) {
                        } else {
                            let goalName = goal.GOMGNO && goal.GOMGNO !== customGoalId ? this.state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                            this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                        }
                    });

            }
            if (this.state.entities.notes.PTSHORTGOALS) {
                Object.keys(this.state.entities.notes.PTSHORTGOALS)
                    .filter(key => {
                        if (this.state.entities.notes.PTSHORTGOALS[key].SGNTNO === this.pk && //PK MATCH
                            this.state.entities.notes.PTSHORTGOALS[key].SGACTIVE && //STG is active
                            (
                                !this.state.entities.notes.PTSHORTGOALS[key].SGDESC //description is empty
                                || !this.state.entities.notes.PTSHORTGOALS[key].SGDATE //date is empty
                                || !this.state.entities.notes.PTSHORTGOALS[key].SGGPNO //progress is empty
                            )
                        ) {
                            return true;
                        }
                        return false;
                    })
                    .forEach(key => {
                        let stGoalName = this.state.entities.notes.PTSHORTGOALS[key].SGNAME ?? (this.state.entities.notes.PTSHORTGOALS[key].SGDESC ?? '<Custom Short Term Goal Not Defined>')
                        this.errors.push({ section: 'Goals', label: stGoalName, to: 'goals/sgno_' + this.state.entities.notes.PTSHORTGOALS[key].SGNO });
                    });
            }

            // must have at least one non-complete goal.  (this is not a requirement of DCs)
            let count = Object.keys(this.state.entities.notes.PTGOALS)
                .filter(key => {
                    if (
                        this.state.entities.notes.PTGOALS[key].GONTNO === this.pk &&
                        this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                        this.state.entities.notes.PTGOALS[key].GOGPNO !== 11
                    ) {
                        return true;
                    }
                    return false;
                }).length;

            if (count === 0) {
                this.errors.push({ section: 'Goals', label: 'One non-completed goal required', to: 'goals' });
            }
        }


        // PN
        if (this.noteType === 3 || this.noteType === 5) {
            // must have at least one non-complete goal.  (this is not a requirement of DCs)
            let count = Object.keys(this.state.entities.notes.PTGOALS)
                .filter(key => {
                    if (
                        this.state.entities.notes.PTGOALS[key].GONTNO === this.pk &&
                        this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                        this.state.entities.notes.PTGOALS[key].GOGPNO !== 11
                    ) {
                        return true;
                    }
                    return false;
                }).length;

            let stgCount = Object.keys(this.state.entities.notes.PTSHORTGOALS)
                .filter(key => {
                    if (
                        this.state.entities.notes.PTSHORTGOALS[key].SGNTNO === this.pk &&
                        this.state.entities.notes.PTSHORTGOALS[key].SGACTIVE === true
                    ) {
                        return true;
                    }
                    return false;
                }).length;

            if (count === 0) {
                this.errors.push({ section: 'Goals', label: 'One non-completed goal required', to: 'goals' });
            }
            if (stgCount === 0 && !this.isCwsOrigin) {
                this.errors.push({ section: 'Short Term Goals', label: 'One non-completed goal required', to: 'goals' });
            }

            if (this.isWc) { // WC Goal Validations
                let masterLifts = [158, 159, 160, 161, 162, 163, 164, 165, 166, 195, 196, 197];
                let masterPushs = [170, 171, 172, 173, 174, 175, 176, 177, 178];
                let liftCount = Object.keys(this.state.entities.notes.PTGOALS)
                    .filter(key => {
                        return (this.state.entities.notes.PTGOALS[key].GONTNO === this.pk
                            && this.state.entities.notes.PTGOALS[key].GODELETED !== true
                            && masterLifts.includes(this.state.entities.notes.PTGOALS[key].GOMGNO))
                    })
                    .length;
                // WC - must have a lift/carry goal
                if (liftCount === 0 && !this.isCwsOrigin) {
                    this.errors.push({ section: 'Goals', label: 'Lift/Carry Goal Required', to: 'goals' });
                }
                if (this.state.entities.notes.PTGOALS) {
                    Object.keys(this.state.entities.notes.PTGOALS)
                        .filter(key => {
                            if (
                                this.state.entities.notes.PTGOALS[key].GONTNO === this.pk &&
                                this.state.entities.notes.PTGOALS[key].GODELETED !== true
                            ) {
                                return true;
                            }
                            return false;
                        })
                        .forEach(key => {
                            let goal = this.state.entities.notes.PTGOALS[key];
                            let goalName = goal.GOMGNO ? this.state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                            if (goal.GOMGNO === 167) {
                                goalName = goal.GOCUSTOM ? goal.GOCUSTOM : '<Custom Activity>';
                            }
                            if (goal.GOMGNO === freeFormGoalId) {
                                goalName = goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                            }
                            if (goal.GOMGNO === 167) {
                                goalName = goal.GOCUSTOM ? goal.GOCUSTOM : '<Custom Activity>';
                            }
                            if (masterLifts.includes(goal.GOMGNO)) { // lifting
                                if (!goal.GODATE ||
                                    !goal.GOCLOF ||
                                    !goal.GOPLOF ||
                                    !goal.GOGPNO ||
                                    !goal.GOOBJECTIVE) {
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            } else if (masterPushs.includes(goal.GOMGNO)) { // pushing
                                if (!goal.GODATE ||
                                    !goal.GOCLOF ||
                                    !goal.GOPLOF ||
                                    !goal.GOGPNO ||
                                    !goal.GOOBJECTIVE) {
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            } else if (goal.GOMGNO === freeFormGoalId &&
                                goal.GOCUSTOM === 'Independence with HEP') {
                                if (!goal.GODATE ||
                                    !goal.GOGPNO) {
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            } else if (goal.GOMGNO === indHepGoalId) {
                            } else if (goal.GOMGNO === freeFormGoalId) {
                                if (!goal.GOCUSTOM ||
                                    !goal.GOFREEFORM ||
                                    !goal.GODATE ||
                                    !goal.GOGPNO
                                ) {
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            } else {
                                // WC Goals - must have Activity, Goal Level, Work Task, Date, CLOF
                                if (!goal.GOMGNO ||
                                    !goal.GOGOALLEVEL ||
                                    !goal.GODATE ||
                                    !goal.GOCLOF ||
                                    !goal.GOGPNO ||
                                    !goal.GOOBJECTIVE) {
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            }
                        });
                }
            } else { // Functional Goal Validations
                let isPeds = this.state.entities.admissions[this.epno].isPeds;
                let isPedsEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
                let isPedsSpeech = this.state.entities.admissions[this.epno].isPedsSpeech;
                let isSpeechEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;

                if ((isPeds && isPedsEnabled) || (isPedsSpeech && isSpeechEnabled)) {
                    if (this.state.entities.notes.PTGOALS) {
                        Object.keys(this.state.entities.notes.PTGOALS)
                            .filter(key => {
                                if (
                                    this.state.entities.notes.PTGOALS[key].GOEVNO === this.pk &&
                                    this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                                    (
                                        !this.state.entities.notes.PTGOALS[key].GOMGNO ||
                                        (this.state.entities.notes.PTGOALS[key].GOMGNO === customGoalId && !this.state.entities.notes.PTGOALS[key].GOCUSTOM) ||
                                        !this.state.entities.notes.PTGOALS[key].GODATE ||
                                        !this.state.entities.notes.PTGOALS[key].GOOBJECTIVE ||
                                        !this.state.entities.notes.PTGOALS[key].GOCURRENTDESC ||
                                        !this.state.entities.notes.PTGOALS[key].GOLONOCURRENT ||
                                        !this.state.entities.notes.PTGOALS[key].GOLONOGOAL

                                    )
                                ) {
                                    return true;
                                }
                                return false;
                            })
                            .forEach(key => {
                                let goal = this.state.entities.notes.PTGOALS[key];
                                let goalName = goal.GOMGNO && goal.GOMGNO !== customGoalId ? this.state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                                if (goal.GOMGNO === indHepGoalId) {
                                } else {
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            });
                    }
                }
                else {
                    // Functional Goals - must have Activity, Goal Level, Objective, Date, PLOF, CLOF
                    if (this.state.entities.notes.PTGOALS) {
                        Object.keys(this.state.entities.notes.PTGOALS)
                            .filter(key => {
                                if (
                                    this.state.entities.notes.PTGOALS[key].GONTNO === this.pk &&
                                    this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                                    (
                                        (
                                            this.state.entities.notes.PTGOALS[key].GOMGNO === freeFormGoalId
                                            && this.state.entities.notes.PTGOALS[key].GOCUSTOM === 'Independence with HEP'
                                            && (
                                                !this.state.entities.notes.PTGOALS[key].GODATE ||
                                                !this.state.entities.notes.PTGOALS[key].GOGPNO
                                            )
                                        )
                                        ||
                                        (
                                            this.state.entities.notes.PTGOALS[key].GOMGNO === freeFormGoalId
                                            && (
                                                !this.state.entities.notes.PTGOALS[key].GOCUSTOM ||
                                                !this.state.entities.notes.PTGOALS[key].GODATE ||
                                                !this.state.entities.notes.PTGOALS[key].GOGPNO
                                            )
                                        )
                                        ||
                                        (
                                            this.state.entities.notes.PTGOALS[key].GOMGNO === freeFormGoalId
                                            && this.state.entities.notes.PTGOALS[key].GOCUSTOM !== 'Independence with HEP'
                                            && (
                                                !this.state.entities.notes.PTGOALS[key].GOCUSTOM ||
                                                !this.state.entities.notes.PTGOALS[key].GOFREEFORM ||
                                                !this.state.entities.notes.PTGOALS[key].GODATE ||
                                                !this.state.entities.notes.PTGOALS[key].GOGPNO
                                            )
                                        )
                                        ||
                                        (
                                            this.state.entities.notes.PTGOALS[key].GOMGNO !== freeFormGoalId
                                            && this.state.entities.notes.PTGOALS[key].GOMGNO !== indHepGoalId
                                            && (
                                                !this.state.entities.notes.PTGOALS[key].GOMGNO ||
                                                (this.state.entities.notes.PTGOALS[key].GOMGNO === customGoalId && !this.state.entities.notes.PTGOALS[key].GOCUSTOM) ||
                                                !this.state.entities.notes.PTGOALS[key].GOGOALLEVEL ||
                                                !this.state.entities.notes.PTGOALS[key].GODATE ||
                                                !this.state.entities.notes.PTGOALS[key].GOPLOF ||
                                                !this.state.entities.notes.PTGOALS[key].GOCLOF ||
                                                !this.state.entities.notes.PTGOALS[key].GOGPNO ||
                                                !this.state.entities.notes.PTGOALS[key].GOOBJECTIVE
                                            )
                                        ) ||
                                        (!this.state.entities.notes.PTGOALS[key].GOGPNO && this.state.entities.notes.PTGOALS[key].GODELETED !== true)
                                    )
                                ) {
                                    return true;
                                }
                                return false;
                            })
                            .forEach(key => {

                                let goal = this.state.entities.notes.PTGOALS[key];
                                if (goal.GOMGNO === indHepGoalId) {
                                } else {
                                    let goalName = goal.GOMGNO && goal.GOMGNO !== customGoalId ? this.state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                                    if (goal.GOMGNO === freeFormGoalId) {
                                        goalName = goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                                    }
                                    this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                                }
                            });
                    }
                }
            }

            if (this.state.entities.notes.PTSHORTGOALS) {
                Object.keys(this.state.entities.notes.PTSHORTGOALS)
                    .filter(key => {
                        if (this.state.entities.notes.PTSHORTGOALS[key].SGNTNO === this.pk && //PK MATCH
                            this.state.entities.notes.PTSHORTGOALS[key].SGACTIVE && //STG is active
                            (
                                !this.state.entities.notes.PTSHORTGOALS[key].SGDESC //description is empty
                                || !this.state.entities.notes.PTSHORTGOALS[key].SGDATE //date is empty
                                || !this.state.entities.notes.PTSHORTGOALS[key].SGGPNO //progress is empty
                            )
                        ) {
                            return true;
                        }
                        return false;
                    })
                    .forEach(key => {
                        let stGoalName = this.state.entities.notes.PTSHORTGOALS[key].SGNAME ?? (this.state.entities.notes.PTSHORTGOALS[key].SGDESC ?? '<Custom Short Term Goal Not Defined>')
                        this.errors.push({ section: 'Goals', label: stGoalName, to: 'goals/sgno_' + this.state.entities.notes.PTSHORTGOALS[key].SGNO });
                    });
            }

            // Deleted goals - must include reason if not a new goal to this note
            // Object.keys(this.state.entities.notes.PTGOALS)
            //     .filter(key => {
            //         let goal = this.state.entities.notes.PTGOALS[key];
            //         if (
            //             goal.GONTNO === this.pk &&
            //             goal.GOGONO &&
            //             goal.GODELETED === true &&
            //             !goal.GODELREASON
            //         ) {
            //             return true;
            //         }
            //         return false;
            //     })
            //     .forEach(key => {
            //         let goal = this.state.entities.notes.PTGOALS[key];
            //         let goalName = goal.GOMGNO && goal.GOMGNO !== customGoalId ? this.state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
            //         this.errors.push({ section: 'Goals', label: goalName + ' delete reason required', to: 'goals/goal_' + goal.GONO });
            //     });

        }
        if (this.noteType === 4 || this.noteType === 6) {
            let isPeds = this.state.entities.admissions[this.epno].isPeds;
            let isPedsEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
            let isPedsSpeech = this.state.entities.admissions[this.epno].isPedsSpeech;
            let isSpeechEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;

            if ((isPeds && isPedsEnabled) || (isPedsSpeech && isSpeechEnabled)) {
                if (this.state.entities.notes.PTGOALS) {
                    Object.keys(this.state.entities.notes.PTGOALS)
                        .filter(key => {
                            if (
                                this.state.entities.notes.PTGOALS[key].GOEVNO === this.pk &&
                                this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                                (
                                    !this.state.entities.notes.PTGOALS[key].GOMGNO ||
                                    (this.state.entities.notes.PTGOALS[key].GOMGNO === customGoalId && !this.state.entities.notes.PTGOALS[key].GOCUSTOM) ||
                                    !this.state.entities.notes.PTGOALS[key].GODATE ||
                                    !this.state.entities.notes.PTGOALS[key].GOOBJECTIVE ||
                                    !this.state.entities.notes.PTGOALS[key].GOCURRENTDESC ||
                                    !this.state.entities.notes.PTGOALS[key].GOLONOCURRENT ||
                                    !this.state.entities.notes.PTGOALS[key].GOLONOGOAL

                                )
                            ) {
                                return true;
                            }
                            return false;
                        })
                        .forEach(key => {
                            let goal = this.state.entities.notes.PTGOALS[key];
                            let goalName = goal.GOMGNO && goal.GOMGNO !== customGoalId ? this.state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                            if (goal.GOMGNO === indHepGoalId) {
                            } else {
                                this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                            }
                        });
                }
            }
            else {
                Object.keys(this.state.entities.notes.PTGOALS)
                    .filter(key => {
                        if (
                            this.state.entities.notes.PTGOALS[key].GONTNO === this.pk &&
                            this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                            this.state.entities.notes.PTGOALS[key].GOMGNO !== freeFormGoalId &&
                            this.state.entities.notes.PTGOALS[key].GOMGNO !== indHepGoalId &&
                            (
                                !this.state.entities.notes.PTGOALS[key].GOCLOF ||
                                !this.state.entities.notes.PTGOALS[key].GOGPNO
                            )
                        ) {
                            return true;
                        } else if (
                            (this.state.entities.notes.PTGOALS[key].GONTNO === this.pk &&
                                this.state.entities.notes.PTGOALS[key].GODELETED !== true &&
                                this.state.entities.notes.PTGOALS[key].GOMGNO === freeFormGoalId &&
                                (
                                    !this.state.entities.notes.PTGOALS[key].GOGPNO
                                )) ||
                            (!this.state.entities.notes.PTGOALS[key].GOGPNO && this.state.entities.notes.PTGOALS[key].GODELETED !== true && this.state.entities.notes.PTGOALS[key].GONTNO === this.pk)
                        ) {
                            return true;
                        }

                        return false;
                    })
                    .forEach(key => {
                        let goal = this.state.entities.notes.PTGOALS[key];
                        if (goal.GOMGNO === indHepGoalId) {
                        } else {
                            let goalName = goal.GOMGNO && goal.GOMGNO !== customGoalId ? this.state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '<Activity Not Defined>';
                            this.errors.push({ section: 'Goals', label: goalName, to: 'goals/goal_' + goal.GONO });
                        }
                    });
            }
            if (this.state.entities.notes.PTSHORTGOALS) {
                Object.keys(this.state.entities.notes.PTSHORTGOALS)
                    .filter(key => {
                        if (this.state.entities.notes.PTSHORTGOALS[key].SGNTNO === this.pk && //PK MATCH
                            this.state.entities.notes.PTSHORTGOALS[key].SGACTIVE && //STG is active
                            (
                                !this.state.entities.notes.PTSHORTGOALS[key].SGDESC //description is empty
                                || !this.state.entities.notes.PTSHORTGOALS[key].SGDATE //date is empty
                                || !this.state.entities.notes.PTSHORTGOALS[key].SGGPNO //progress is empty
                            )
                        ) {
                            return true;
                        }
                        return false;
                    })
                    .forEach(key => {
                        let stGoalName = this.state.entities.notes.PTSHORTGOALS[key].SGNAME ?? (this.state.entities.notes.PTSHORTGOALS[key].SGDESC ?? '<Custom Short Term Goal Not Defined>')
                        this.errors.push({ section: 'Goals', label: stGoalName, to: 'goals/sgno_' + this.state.entities.notes.PTSHORTGOALS[key].SGNO });
                    });
            }
        }
    }

    static fillAssessmentWpErrors() {
        if (this.noteType === 1) {
            if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBWCDOLCURRENTLIFTFREQ) {
                this.errors.push({ section: 'Assessment', label: 'Current PDC - Lift Freq.', to: 'assessment/ass_current_pdc' });
            }
            if (!this.state.entities.notes.PTEVAL[this.pk].EVSUBWCDOLCURRENTLIFT) {
                this.errors.push({ section: 'Assessment', label: 'Current PDC - Lift', to: 'assessment/ass_current_pdc' });
            }
        }
        let showDetails = this.state.entities.notes.PTASSESSMENT[this.asno]?.ASBARRIERATTEND ||
            this.state.entities.notes.PTASSESSMENT[this.asno]?.ASBARRIERCOMPLIANCE ||
            this.state.entities.notes.PTASSESSMENT[this.asno]?.ASBARRIERMEDICAL ||
            this.state.entities.notes.PTASSESSMENT[this.asno]?.ASBARRIERPSYCHO ||
            this.state.entities.notes.PTASSESSMENT[this.asno]?.ASBARRIEROTHER ? true : false;

        if (showDetails && !this.state.entities.notes.PTASSESSMENT[this.asno].ASBARRIERDETAILS) {
            this.errors.push({ section: 'Assessment', label: 'Details about resolution are required', to: 'assessment/assessment_barriers' });
        }

        if (this.noteType !== 1) {
            let assessment = this.state.entities.notes.PTASSESSMENT[Object.keys(this.state.entities.notes.PTASSESSMENT)
                .find(x => this.state.entities.notes.PTASSESSMENT[x].ASNTNO === this.pk && this.noteType !== 1)];

            if (!assessment.ASFREEFORM) {
                this.errors.push({ section: 'Assessment', label: 'Assessment text area value is required', to: 'assessment' });
            }
        }
    }

    static fillWpPlanErrors() {
        // EVAL
        if (this.noteType === 1) {
            let plan = this.state.entities.notes.PTPLAN[Object.keys(this.state.entities.notes.PTPLAN)
                .find(x => this.state.entities.notes.PTPLAN[x].PLEVNO === this.pk)];
            // must have PLPOCTIMESMAX, PLPOCDURMAX, PLPOCDURTYPE
            if (plan.PLWPNOTCANDIDATE === null && (!plan.PLPOCTIMESMAX ||
                !plan.PLPOCDURMAX)) {
                this.errors.push({ section: 'Plan', label: 'Frequency and Duration Required', to: 'plan' });
            }

        }

        if (this.noteType === 2 || this.noteType === 3 || this.noteType === 5) {
            let plan = this.state.entities.notes.PTPLAN[Object.keys(this.state.entities.notes.PTPLAN)
                .find(x => this.state.entities.notes.PTPLAN[x].PLNTNO === this.pk)];
            if (!plan.PLRTMDC) {
                if (!plan.PLNEWPOC && !plan.PLCONTINUE) {
                    this.errors.push({ section: 'Plan', label: 'Continue with POC or New POC Required', to: 'plan' });
                }
                // must have PLPOCTIMESMAX, PLPOCTIMETYPE, PLPOCDURMAX, PLPOCDURTYPE
                if (plan.PLNEWPOC && (
                    !plan.PLPOCTIMESMAX ||
                    !plan.PLPOCDURMAX)) {
                    this.errors.push({ section: 'Plan', label: 'Frequency and Duration Required', to: 'plan' });
                }
            }
        }

        if (this.noteType === 4 || this.noteType === 6) {
            let plan = this.state.entities.notes.PTPLAN[Object.keys(this.state.entities.notes.PTPLAN)
                .find(x => this.state.entities.notes.PTPLAN[x].PLNTNO === this.pk)];

            let isCheckboxedRequired = plan.PLWPDCGOALSMET === null
                && plan.PLWPDCINSTRUCTEDHEP === null
                && plan.PLWPDCPOORCOMPLIANCE === null
                && plan.PLWPDCMETJOBREQS === null
                && plan.PLWPDCFCE === null;
            if (isCheckboxedRequired) {
                this.errors.push({ section: 'Plan', label: 'At least one checkbox must be selected.', to: 'plan' });
            }

            if (plan.PLWPDCGOALSMET !== null && plan.PLWPDCGOALSMETPERCENT === null) {
                this.errors.push({ section: 'Plan', label: 'The % is required - Goals met.', to: 'plan' });
            }
        }

        let plno = this.state.entities.notes.PTPLAN[Object.keys(this.state.entities.notes.PTPLAN)
            .find(x => (this.state.entities.notes.PTPLAN[x].PLEVNO === this.pk && this.noteType === 1)
                || (this.state.entities.notes.PTPLAN[x].PLNTNO === this.pk && this.noteType !== 1))].PLNO;

        if (this.state.entities.notes.PTPLAN[plno].PLSTUDENTPARTICIPATED === true && !this.state.entities.notes.PTPLAN[plno].PLSTUDENTTHNO) {
            this.errors.push({ section: 'Plan', label: 'Student is required', to: 'plan' });
        }


    }

    static fillAssessmentErrors() {
        let isPeds = this.state.entities.admissions[this.epno].isPeds;
        let isPedsEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
        let isPedsSpeech = this.state.entities.admissions[this.epno].isPedsSpeech;
        let isSpeechEnabled = this.state.entities.masterData.PROPS ? this.state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;

        let outRequired = true;

        if (this.noteType === 2 && ((isPeds && isPedsEnabled) || (isPedsSpeech && isSpeechEnabled))) {
            outRequired = false;
        }

        let assessment = this.state.entities.notes.PTASSESSMENT[Object.keys(this.state.entities.notes.PTASSESSMENT)
            .find(x => (this.state.entities.notes.PTASSESSMENT[x].ASEVNO === this.pk && this.noteType === 1)
                || (this.state.entities.notes.PTASSESSMENT[x].ASNTNO === this.pk && this.noteType !== 1))];

        let plan = this.state.entities.notes.PTPLAN[Object.keys(this.state.entities.notes.PTPLAN)
            .find(x => this.state.entities.notes.PTPLAN[x].PLNTNO === this.pk)];

        if (assessment.ASCOTRT && (!assessment.ASCOTRTURNO || !assessment.ASCOTRTDETAILS)) {
            this.errors.push({ section: 'Assessment', label: 'Co-treatment details', to: 'assessment/assessment' });
        }

        if (!assessment.ASOLD) {
            if (plan?.PLDISCHARGEREASON?.trim() !== 'DNR' && !assessment.ASFREEFORM) {
                this.errors.push({ section: 'Assessment', label: 'Skills Delivered Today', to: 'assessment/assessment' });
            }

            // EVAL
            if (this.noteType === 1) {

                if (
                    !assessment.ASREHABPOTENTIAL ||
                    (assessment.ASAWAREDIAG === null)
                ) {
                    this.errors.push({ section: 'Assessment', label: 'Complete rehab potential', to: 'assessment' });
                }
                if (!this.state.entities.notes.PTEVAL[this.pk].EVOBJNOOUTCOMEREASON) {
                    let outCount = Object.keys(this.state.entities.notes.PTOUTMEASURES)
                        .filter(x => this.state.entities.notes.PTOUTMEASURES[x].OMEVNO === this.pk &&
                            this.state.entities.notes.PTOUTMEASURES[x].OMONASSESSMENT)
                        .length;

                    if ((outCount === 0 || !assessment.ASOUTCOMEDESC) && outRequired) {
                        this.errors.push({ section: 'Assessment', label: 'Outcome Measures', to: 'assessment/assessment_outcomes' });
                    }
                }
            }
        }

        // let outMeasures = Object.keys(this.state.entities.notes.PTOUTMEASURES)
        // .filter(x => this.state.entities.notes.PTOUTMEASURES[x].OMNTNO === this.pk).map(key => this.state.entities.notes.PTOUTMEASURES[key]);

        // outMeasures.forEach(measure => {
        //     if (measure.OMNAME !== null && measure.OMSCORE === null) {
        //         this.errors.push({
        //             section: 'Assessment',
        //             label: 'Outcome Measure - score required',
        //             to: 'assessment/assessment_outcomes'
        //         });
        //     }
        // });


        if (assessment.ASOLD) {
            if (this.noteType === 1) {
                if (!assessment.ASISBUILDER) {
                    if (!assessment.ASFREEFORM) {
                        this.errors.push({ section: 'Assessment', label: 'Complete Assessment', to: 'assessment' });
                    }
                } else {
                    let flagCount = Object.keys(this.state.entities.notes.PTASSESSMENTFLAGS)
                        .filter(x => this.state.entities.notes.PTASSESSMENTFLAGS[x].AFASNO === assessment.ASNO &&
                            this.state.entities.notes.PTASSESSMENTFLAGS[x].AFLIMITATION)
                        .length;

                    let goalCount = Object.keys(this.state.entities.notes.PTGOALS)
                        .filter(x => this.state.entities.notes.PTGOALS[x].GOEVNO === this.pk &&
                            !this.state.entities.notes.PTGOALS[x].GODELETED === true &&
                            this.state.entities.notes.PTGOALS[x].GODIFFICULT)
                        .length;

                    if (
                        !assessment.ASSKILLS ||
                        (flagCount === 0 && !assessment.ASLIMITATIONSTXT) ||
                        (goalCount === 0 && !assessment.ASDIFFICULTYTXT)
                    ) {
                        this.errors.push({ section: 'Assessment', label: 'Complete required fields', to: 'assessment' });
                    }
                }
                if (!this.state.entities.notes.PTEVAL[this.pk].EVOBJNOOUTCOMEREASON) {
                    let outCount = Object.keys(this.state.entities.notes.PTOUTMEASURES)
                        .filter(x => this.state.entities.notes.PTOUTMEASURES[x].OMEVNO === this.pk &&
                            this.state.entities.notes.PTOUTMEASURES[x].OMONASSESSMENT)
                        .length;

                    if ((outCount === 0 || !assessment.ASOUTCOMEDESC) && outRequired) {
                        this.errors.push({ section: 'Assessment', label: 'Outcome Measures', to: 'assessment/assessment_outcomes' });
                    }
                }



            }
        }


        if (this.noteType === 2) {
            if (assessment.ASOLD) {
                if (!assessment.ASISBUILDER) {
                    if (!assessment.ASFREEFORM) {
                        this.errors.push({ section: 'Assessment', label: 'Complete Assessment', to: 'assessment' });
                    }
                } else {
                    let flagCount = Object.keys(this.state.entities.notes.PTASSESSMENTFLAGS)
                        .filter(x => this.state.entities.notes.PTASSESSMENTFLAGS[x].AFASNO === assessment.ASNO &&
                            this.state.entities.notes.PTASSESSMENTFLAGS[x].AFLIMITATION)
                        .length;

                    let goalCount = Object.keys(this.state.entities.notes.PTGOALS)
                        .filter(x => this.state.entities.notes.PTGOALS[x].GONTNO === this.pk &&
                            !this.state.entities.notes.PTGOALS[x].GODELETED === true &&
                            this.state.entities.notes.PTGOALS[x].GODIFFICULT)
                        .length;

                    if (
                        !assessment.ASSKILLS ||
                        (flagCount === 0 && !assessment.ASLIMITATIONSTXT) ||
                        (goalCount === 0 && !assessment.ASDIFFICULTYTXT)
                    ) {
                        this.errors.push({ section: 'Assessment', label: 'Complete required fields', to: 'assessment' });
                    }
                }
            }
        }

        if (this.noteType === 3 || this.noteType === 5) {
            if (assessment.ASOLD) {
                if (!assessment.ASISBUILDER) {
                    if (!assessment.ASFREEFORM) {
                        this.errors.push({ section: 'Assessment', label: 'Complete Assessment', to: 'assessment' });
                    }
                } else {

                    let flagCount = Object.keys(this.state.entities.notes.PTASSESSMENTFLAGS)
                        .filter(x => this.state.entities.notes.PTASSESSMENTFLAGS[x].AFASNO === assessment.ASNO &&
                            this.state.entities.notes.PTASSESSMENTFLAGS[x].AFLIMITATION)
                        .length;

                    let goalCount = Object.keys(this.state.entities.notes.PTGOALS)
                        .filter(x => this.state.entities.notes.PTGOALS[x].GONTNO === this.pk &&
                            !this.state.entities.notes.PTGOALS[x].GODELETED === true &&
                            this.state.entities.notes.PTGOALS[x].GODIFFICULT)
                        .length;

                    let flagCount2 = Object.keys(this.state.entities.notes.PTASSESSMENTFLAGS)
                        .filter(x => this.state.entities.notes.PTASSESSMENTFLAGS[x].AFASNO === assessment.ASNO &&
                            this.state.entities.notes.PTASSESSMENTFLAGS[x].AFIMPROVEMENT)
                        .length;

                    let goalCount2 = Object.keys(this.state.entities.notes.PTGOALS)
                        .filter(x => this.state.entities.notes.PTGOALS[x].GONTNO === this.pk &&
                            !this.state.entities.notes.PTGOALS[x].GODELETED === true &&
                            this.state.entities.notes.PTGOALS[x].GOIMPROVE)
                        .length;

                    if (
                        !assessment.ASSKILLS ||
                        !assessment.ASRESULTOFSKILLS ||
                        (flagCount === 0 && !assessment.ASLIMITATIONSTXT) ||
                        (goalCount === 0 && !assessment.ASDIFFICULTYTXT) ||
                        (flagCount2 === 0 && !assessment.ASIMPROVETXT) ||
                        (goalCount2 === 0 && !assessment.ASABILITYTO)
                    ) {
                        this.errors.push({ section: 'Assessment', label: 'Complete required fields', to: 'assessment' });
                    }
                }
            }
            if (!this.state.entities.notes.PTNOTE[this.pk].NTOBJNOOUTCOMEREASON) {
                let outCount = Object.keys(this.state.entities.notes.PTOUTMEASURES)
                    .filter(x => this.state.entities.notes.PTOUTMEASURES[x].OMNTNO === this.pk &&
                        this.state.entities.notes.PTOUTMEASURES[x].OMONASSESSMENT)
                    .length;

                if ((outCount === 0 || !assessment.ASOUTCOMEDESC) && outRequired) {
                    this.errors.push({ section: 'Assessment', label: 'Outcome Measures', to: 'assessment/assessment_outcomes' });
                }
            }


            if ((!assessment.ASBARRIERNONE &&
                !assessment.ASBARRIERATTEND &&
                !assessment.ASBARRIERCOMPLIANCE &&
                !assessment.ASBARRIERMEDICAL &&
                !assessment.ASBARRIERPSYCHO &&
                !assessment.ASBARRIEROTHER) ||
                (assessment.ASBARRIEROTHER && !assessment.ASBARRIEROTHERTXT) ||
                ((assessment.ASBARRIERATTEND ||
                    assessment.ASBARRIERCOMPLIANCE ||
                    assessment.ASBARRIERMEDICAL ||
                    assessment.ASBARRIERPSYCHO ||
                    assessment.ASBARRIEROTHER
                ) && (assessment.ASBARRIERRESOLVED === null || !assessment.ASBARRIERDETAILS))
            ) {
                this.errors.push({ section: 'Assessment', label: 'Barriers to Progress', to: 'assessment/assessment_barriers' });
            }

        }

        if (this.noteType === 4 || this.noteType === 6) {
            if (plan?.PLDISCHARGEREASON?.trim() === 'DNR' && this.noteType === 4) {
                return;
            }
            if (assessment.ASOLD) {
                if (!assessment.ASISBUILDER) {
                    if (plan?.PLDISCHARGEREASON?.trim() !== 'DNR' && !assessment.ASFREEFORM) {
                        this.errors.push({ section: 'Assessment', label: 'Complete Assessment', to: 'assessment' });
                    }
                } else {
                    let flagCount2 = Object.keys(this.state.entities.notes.PTASSESSMENTFLAGS)
                        .filter(x => this.state.entities.notes.PTASSESSMENTFLAGS[x].AFASNO === assessment.ASNO &&
                            this.state.entities.notes.PTASSESSMENTFLAGS[x].AFIMPROVEMENT)
                        .length;

                    let goalCount2 = Object.keys(this.state.entities.notes.PTGOALS)
                        .filter(x => this.state.entities.notes.PTGOALS[x].GONTNO === this.pk &&
                            !this.state.entities.notes.PTGOALS[x].GODELETED === true &&
                            this.state.entities.notes.PTGOALS[x].GOIMPROVE)
                        .length;

                    if (
                        !assessment.ASRESULTOFSKILLS ||
                        (flagCount2 === 0 && !assessment.ASIMPROVETXT) ||
                        (goalCount2 === 0 && !assessment.ASABILITYTO)
                    ) {
                        this.errors.push({ section: 'Assessment', label: 'Complete required fields', to: 'assessment' });
                    }
                }
            }
            if (this.noteType !== 4) {
                if (!this.state.entities.notes.PTNOTE[this.pk].NTOBJNOOUTCOMEREASON) {
                    let outCount = Object.keys(this.state.entities.notes.PTOUTMEASURES)
                        .filter(x => this.state.entities.notes.PTOUTMEASURES[x].OMNTNO === this.pk &&
                            this.state.entities.notes.PTOUTMEASURES[x].OMONASSESSMENT)
                        .length;

                    if ((outCount === 0 || !assessment.ASOUTCOMEDESC) && outRequired) {
                        this.errors.push({ section: 'Assessment', label: 'Outcome Measures', to: 'assessment/assessment_outcomes' });
                    }
                }
            }

            if ((!assessment.ASBARRIERNONE &&
                !assessment.ASBARRIERATTEND &&
                !assessment.ASBARRIERCOMPLIANCE &&
                !assessment.ASBARRIERMEDICAL &&
                !assessment.ASBARRIERPSYCHO &&
                !assessment.ASBARRIEROTHER) ||
                (assessment.ASBARRIEROTHER && !assessment.ASBARRIEROTHERTXT) ||
                ((assessment.ASBARRIERATTEND ||
                    assessment.ASBARRIERCOMPLIANCE ||
                    assessment.ASBARRIERMEDICAL ||
                    assessment.ASBARRIERPSYCHO ||
                    assessment.ASBARRIEROTHER
                ) && (assessment.ASBARRIERRESOLVED === null || !assessment.ASBARRIERDETAILS))
            ) {
                this.errors.push({ section: 'Assessment', label: 'Barriers to Progress', to: 'assessment/assessment_barriers' });
            }

        }
    }

    static fillPlanErrors() {

        // EVAL
        if (this.noteType === 1) {
            let plan = this.state.entities.notes.PTPLAN[Object.keys(this.state.entities.notes.PTPLAN)
                .find(x => this.state.entities.notes.PTPLAN[x].PLEVNO === this.pk)];

            if (!this.isSpeech) {
                // must have PLEVAL, or PLEVALONLY
                if (!plan.PLEVAL && !plan.PLEVALONLY) {
                    this.errors.push({ section: 'Plan', label: 'Eval or Eval Only Required', to: 'plan' });
                }
            }
            else {
                if (!plan.PLEVALONLY &&
                    !plan.PLSPAUGDEVICE &&
                    !plan.PLSPSWALLOWEVAL &&
                    !plan.PLSPVOICE &&
                    !plan.PLSPLANGCOMP &&
                    !plan.PLSPSOUNDPROD &&
                    !plan.PLSPFLUENCY
                ) {
                    this.errors.push({ section: 'Plan', label: 'Eval Type or Eval Only Required', to: 'plan' });
                }
            }


            // must have PLPOCTIMESMAX, PLPOCTIMETYPE, PLPOCDURMAX, PLPOCDURTYPE
            if (!plan.PLPOCTIMESMAX ||
                !plan.PLPOCTIMETYPE ||
                !plan.PLPOCDURMAX ||
                !plan.PLPOCDURTYPE) {
                this.errors.push({ section: 'Plan', label: 'Frequency and Duration Required', to: 'plan' });
            }

        }
        if (this.noteType === 2) {
            let plan = this.state.entities.notes.PTPLAN[Object.keys(this.state.entities.notes.PTPLAN)
                .find(x => this.state.entities.notes.PTPLAN[x].PLNTNO === this.pk)];

            if (plan.PLPROGRESSING === null || (plan.PLPROGRESSING === false && plan.PLCOMMENTS === null)) {
                this.errors.push({ section: 'Plan', label: 'Complete required fields', to: 'plan' })
            }
        }
        if (this.noteType === 3 || this.noteType === 5) {
            let plan = this.state.entities.notes.PTPLAN[Object.keys(this.state.entities.notes.PTPLAN)
                .find(x => this.state.entities.notes.PTPLAN[x].PLNTNO === this.pk)];
            if (!plan.PLRTMDC) {
                if (!plan.PLNEWPOC && !plan.PLCONTINUE) {
                    this.errors.push({ section: 'Plan', label: 'Continue with POC or New POC Required', to: 'plan' });
                }
                // must have PLPOCTIMESMAX, PLPOCTIMETYPE, PLPOCDURMAX, PLPOCDURTYPE
                if (plan.PLNEWPOC && (
                    !plan.PLPOCTIMESMAX ||
                    !plan.PLPOCTIMETYPE ||
                    !plan.PLPOCDURMAX ||
                    !plan.PLPOCDURTYPE)) {
                    this.errors.push({ section: 'Plan', label: 'Frequency and Duration Required', to: 'plan' });
                }
            }
        }

        if (this.noteType === 4 || this.noteType === 6) {
            let plan = this.state.entities.notes.PTPLAN[Object.keys(this.state.entities.notes.PTPLAN)
                .find(x => this.state.entities.notes.PTPLAN[x].PLNTNO === this.pk)];
            if (plan?.PLDISCHARGEREASON?.trim() !== 'DNR' && (
                !plan?.PLDISCHARGEREASON ||
                (plan?.PLDISCHARGEREASON.trim() !== 'PD' && (
                    !plan.PLPROGNOSIS ||
                    !plan.PLINDHEP ||
                    !plan.PLCOMPLIANCEHEP
                )) ||
                (plan?.PLDISCHARGEREASON.trim() === 'GPM' && !plan.PLDISCHARGEPERCGOALSMET) ||
                (plan?.PLDISCHARGEREASON.trim() === 'OTH' && !plan.PLDISCHARGEOTHER)
            )) {
                this.errors.push({ section: 'Plan', label: 'Complete required fields.', to: 'plan' });
            }
        }

        let plno = this.state.entities.notes.PTPLAN[Object.keys(this.state.entities.notes.PTPLAN)
            .find(x => (this.state.entities.notes.PTPLAN[x].PLEVNO === this.pk && this.noteType === 1)
                || (this.state.entities.notes.PTPLAN[x].PLNTNO === this.pk && this.noteType !== 1))].PLNO;

        if (this.state.entities.notes.PTPLAN[plno].PLSTUDENTPARTICIPATED === true && !this.state.entities.notes.PTPLAN[plno].PLSTUDENTTHNO) {
            this.errors.push({ section: 'Plan', label: 'Student is required', to: 'plan' });
        }

    }

    static fillChargesErrors() {
        // Diagnosis Validations
        // at least one medical diag
        if ((this.state.entities.diagnosis ? Object.keys(this.state.entities.diagnosis)
            .filter(x => this.state.entities.diagnosis[x].epno === this.epno &&
                this.state.entities.diagnosis[x].type === 'Medical')
            .length : 0) === 0) {
            this.errors.push({ section: 'Charges', label: 'Medical Diagnosis Required', to: 'charges' });
        }
        // if medicare, prog type 360, or PAYERS_REQ_TREATMENT_DIAG, at least one trt diag
        if (this.state.entities.admissions[this.epno].requireTrtDiag &&
            (this.state.entities.diagnosis ? Object.keys(this.state.entities.diagnosis)
                .filter(x => this.state.entities.diagnosis[x].epno === this.epno &&
                    this.state.entities.diagnosis[x].type === 'Treatment')
                .length : 0) === 0) {
            this.errors.push({ section: 'Charges', label: 'Treatment Diagnosis Required', to: 'charges' });
        }
        // onsetDates - evalType pediatric, medicaid, NC, age < 21 
        if (this.state.entities.admissions[this.epno].requireDiagOnsets &&
            (this.state.entities.diagnosis ? Object.keys(this.state.entities.diagnosis)
                .filter(x => this.state.entities.diagnosis[x].epno === this.epno &&
                    !this.state.entities.diagnosis[x].onset)
                .length : 0) > 0) {
            this.errors.push({ section: 'Charges', label: 'Diagnosis Onsets Required', to: 'charges' });
        }

        if (this.noteType === 1) { // EVAL
            if (this.cnRequiresTime) {
                if ((!this.state.entities.notes.PTEVAL[this.pk].EVTIMEIN || !this.state.entities.notes.PTEVAL[this.pk].EVTIMEOUT)) {
                    this.errors.push({ section: 'Charges', label: 'Time in/out required for this payer', to: 'charges' });
                }
                if (this.state.entities.notes.PTEVAL[this.pk].EVTIMEIN && this.state.entities.notes.PTEVAL[this.pk].EVTIMEOUT
                    && this.state.entities.notes.PTEVAL[this.pk].EVTIMEOUT < this.state.entities.notes.PTEVAL[this.pk].EVTIMEIN) {
                    this.errors.push({ section: 'Charges', label: 'Time out must be after time in', to: 'charges' });
                }
            }
            if (!this.scribing) {
                if (this.state.entities.authentication.user.isStudent) {
                    //check for CI 
                    if (!this.state.entities.notes.PTEVAL[this.pk].EVCITHNO) {
                        this.errors.push({ section: 'Charges', label: 'Clinical Instructor Required', to: 'charges' });
                    }
                    else {
                        //get selected CI and check if the are licensed
                        let selectedCI = Object.keys(this.state.entities.notes.CILIST)
                            .find(key => (this.state.entities.notes.CILIST[key].epno === this.epno && this.state.entities.notes.CILIST[key].THNO === this.state.entities.notes.PTEVAL[this.pk].EVCITHNO));

                        if (selectedCI !== undefined) {
                            if (!this.state.entities.notes.CILIST[selectedCI].TTISLICENSED && !this.state.entities.notes.PTEVAL[this.pk].EVTHNOSUPV) {
                                this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                            }
                        }
                    }
                }
                else if (!this.state.entities.authentication.user.islicensed &&
                    !this.state.entities.notes.PTEVAL[this.pk].EVTHNOSUPV) {
                    this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                }
            }
            if (!this.state.entities.notes.PTEVAL[this.pk].EVTRTDATE) {
                this.errors.push({ section: 'Charges', label: 'Treatment Date Required', to: 'charges' });
            }
            if (this.state.entities.notes.PTEVAL[this.pk].EVTELEHEALTH === null) {
                this.errors.push({ section: 'Charges', label: 'Telehealth Indicator Required', to: 'charges' });
            }
            // billable charges OR EVNOCHARGEREASON
            if (!this.state.entities.notes.PTEVAL[this.pk].hasCharges) {
                if (!this.state.entities.notes.PTEVAL[this.pk].EVNOCHARGEREASON &&
                    this.state.ui.notes[this.noteId].computedChargesVisible === false) {
                    this.errors.push({ section: 'Charges', label: 'Computed charges are required', to: 'charges' });
                } else if (!this.state.entities.notes.PTEVAL[this.pk].EVNOCHARGEREASON &&
                    this.state.ui.notes[this.noteId].computedChargesVisible === true &&
                    // mlcomputedcharges contains at least one CCBILLABLE
                    Object.keys(this.state.entities.notes.MLCOMPUTEDCHARGES)
                        .filter(key => this.state.entities.notes.MLCOMPUTEDCHARGES[key].CCCRNO === this.state.entities.notes.MLCHARGEREQUESTS[this.xlno].CRNO &&
                            this.state.entities.notes.MLCOMPUTEDCHARGES[key].CCBILLABLE === true).length === 0) {
                    this.errors.push({ section: 'Charges', label: 'Must have billable charge or specify reason for no charges', to: 'charges' });
                }
            }

        } else if (this.noteType === 2 || this.noteType === 5 || this.noteType === 6) { // DN, PN/DN, DC/DN
            if (this.cnRequiresTime) {
                if (!this.state.entities.notes.PTNOTE[this.pk].NTTIMEIN || !this.state.entities.notes.PTNOTE[this.pk].NTTIMEOUT) {
                    this.errors.push({ section: 'Charges', label: 'Time in/out required for this payer', to: 'charges' });
                }
                if (this.state.entities.notes.PTNOTE[this.pk].NTTIMEIN && this.state.entities.notes.PTNOTE[this.pk].NTTIMEOUT
                    && this.state.entities.notes.PTNOTE[this.pk].NTTIMEOUT < this.state.entities.notes.PTNOTE[this.pk].NTTIMEIN) {
                    this.errors.push({ section: 'Charges', label: 'Time out must be after time in', to: 'charges' });
                }
            }

            if (!this.scribing) {
                if (this.state.entities.authentication.user.isStudent) {
                    //check for CI 
                    if (!this.state.entities.notes.PTNOTE[this.pk].NTCITHNO) {
                        this.errors.push({ section: 'Charges', label: 'Clinical Instructor Required', to: 'charges' });
                    }
                    else {
                        //get selected CI and check if the are licensed
                        let selectedCI = Object.keys(this.state.entities.notes.CILIST)
                            .find(key => (this.state.entities.notes.CILIST[key].epno === this.epno && this.state.entities.notes.CILIST[key].THNO === this.state.entities.notes.PTNOTE[this.pk].NTCITHNO));

                        if (selectedCI !== undefined) {
                            if (!this.state.entities.notes.CILIST[selectedCI].TTISLICENSED && !this.state.entities.notes.PTNOTE[this.pk].NTTHNOSUPV) {
                                this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                            }
                        }
                    }
                }
                else if (!this.state.entities.authentication.user.islicensed &&
                    !this.state.entities.notes.PTNOTE[this.pk].NTTHNOSUPV) {
                    this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                }
            }
            if (!this.state.entities.notes.PTNOTE[this.pk]?.NTTRTDATE) {
                this.errors.push({ section: 'Charges', label: 'Treatment Date Required', to: 'charges' });
            }
            if (this.state.entities.notes.PTNOTE[this.pk].NTTELEHEALTH === null) {
                this.errors.push({ section: 'Charges', label: 'Telehealth Indicator Required', to: 'charges' });
            }
            // billable charges OR EVNOCHARGEREASON
            if (!this.state.entities.notes.PTNOTE[this.pk].hasCharges) {
                if (!this.state.entities.notes.PTNOTE[this.pk].NTNOCHARGEREASON &&
                    this.state.ui.notes[this.noteId].computedChargesVisible === false) {
                    this.errors.push({ section: 'Charges', label: 'Computed charges are required', to: 'charges' });
                } else if (!this.state.entities.notes.PTNOTE[this.pk].NTNOCHARGEREASON &&
                    this.state.ui.notes[this.noteId].computedChargesVisible === true &&
                    // mlcomputedcharges contains at least one CCBILLABLE
                    Object.keys(this.state.entities.notes.MLCOMPUTEDCHARGES)
                        .filter(key => this.state.entities.notes.MLCOMPUTEDCHARGES[key].CCCRNO === this.state.entities.notes.MLCHARGEREQUESTS[this.xlno].CRNO &&
                            this.state.entities.notes.MLCOMPUTEDCHARGES[key].CCBILLABLE === true).length === 0) {
                    this.errors.push({ section: 'Charges', label: 'Must have billable charge or specify reason for no charges', to: 'charges' });
                }
            }
        } else if (this.noteType === 3 || this.noteType === 4) {
            if (!this.state.entities.notes.PTNOTE[this.pk].NTMEASUREMENTDATE) {
                this.errors.push({ section: 'Charges', label: 'Measurement Date Required', to: 'charges' });
            }
            if (this.state.entities.authentication.user.isStudent) {
                //check for CI 
                if (!this.state.entities.notes.PTNOTE[this.pk].NTCITHNO) {
                    this.errors.push({ section: 'Charges', label: 'Clinical Instructor Required', to: 'charges' });
                }
                else {
                    //get selected CI and check if the are licensed
                    let selectedCI = Object.keys(this.state.entities.notes.CILIST)
                        .find(key => (this.state.entities.notes.CILIST[key].epno === this.epno && this.state.entities.notes.CILIST[key].THNO === this.state.entities.notes.PTNOTE[this.pk].NTCITHNO));

                    if (selectedCI !== undefined) {
                        if (!this.state.entities.notes.CILIST[selectedCI].TTISLICENSED && !this.state.entities.notes.PTNOTE[this.pk].NTTHNOSUPV) {
                            this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                        }
                    }
                }
            }
            else if (!this.scribing) {
                if (!this.state.entities.authentication.user.islicensed &&
                    !this.state.entities.notes.PTNOTE[this.pk].NTTHNOSUPV) {
                    this.errors.push({ section: 'Charges', label: 'Supervising Therapist Required', to: 'charges' });
                }
            }
        }

        this.fillGroupErrors();


    }

    static fillGroupErrors() {

        let groupKey = Object.keys(this.state.entities.notes.MLOTHER)
            .find(key => {
                return (this.state.entities.notes.MLOTHER[key].XLOEXLNO === this.xlno &&
                    this.state.entities.notes.MLOTHER[key].XLOEPERFORMED === true &&
                    Object.keys(this.state.entities.masterData.MLMASTEROTHER)
                        .find(x => this.state.entities.masterData.MLMASTEROTHER[x].OENO === this.state.entities.notes.MLOTHER[key].XLOEOENO &&
                            this.state.entities.masterData.MLMASTEROTHER[x].OECODE === '97150'
                        ) !== undefined
                )
            });

        if (groupKey !== undefined) {

            // num in group required
            if (!this.state.entities.notes.MLEXLOG[this.xlno].XLNUMINGROUP ||
                this.state.entities.notes.MLEXLOG[this.xlno].XLNUMINGROUP === 0 ||

                // if isgroup but no items marked as group
                Object.keys(this.state.entities.notes.MLTHERACT)
                    .filter(key => this.state.entities.notes.MLTHERACT[key].XLTAXLNO === this.xlno &&
                        this.state.entities.notes.MLTHERACT[key].XLTAPERFORMED === true &&
                        this.state.entities.notes.MLTHERACT[key].XLTAISGROUP === true).length
                +
                Object.keys(this.state.entities.notes.MLSELFCARE)
                    .filter(key => this.state.entities.notes.MLSELFCARE[key].XLSCXLNO === this.xlno &&
                        this.state.entities.notes.MLSELFCARE[key].XLSCPERFORMED === true &&
                        this.state.entities.notes.MLSELFCARE[key].XLSCISGROUP === true).length
                +
                Object.keys(this.state.entities.notes.MLNEURO)
                    .filter(key => this.state.entities.notes.MLNEURO[key].XLNEXLNO === this.xlno &&
                        this.state.entities.notes.MLNEURO[key].XLNEPERFORMED === true &&
                        this.state.entities.notes.MLNEURO[key].XLNEISGROUP === true).length
                +
                Object.keys(this.state.entities.notes.MLTHEREX)
                    .filter(key => this.state.entities.notes.MLTHEREX[key].XLTEXLNO === this.xlno &&
                        this.state.entities.notes.MLTHEREX[key].XLTEPERFORMED === true &&
                        this.state.entities.notes.MLTHEREX[key].XLTEISGROUP === true).length
                +
                Object.keys(this.state.entities.notes.MLMANUAL)
                    .filter(key => this.state.entities.notes.MLMANUAL[key].XLMAXLNO === this.xlno &&
                        this.state.entities.notes.MLMANUAL[key].XLMAPERFORMED === true &&
                        this.state.entities.notes.MLMANUAL[key].XLMAISGROUP === true).length
                +
                Object.keys(this.state.entities.notes.MLGAIT)
                    .filter(key => this.state.entities.notes.MLGAIT[key].XLGAXLNO === this.xlno &&
                        this.state.entities.notes.MLGAIT[key].XLGAPERFORMED === true &&
                        this.state.entities.notes.MLGAIT[key].XLGAISGROUP === true).length
                +
                Object.keys(this.state.entities.notes.MLAQUATICS)
                    .filter(key => this.state.entities.notes.MLAQUATICS[key].XLAQXLNO === this.xlno &&
                        this.state.entities.notes.MLAQUATICS[key].XLAQPERFORMED === true &&
                        this.state.entities.notes.MLAQUATICS[key].XLAQISGROUP === true).length
                +
                Object.keys(this.state.entities.notes.MLMODALITIES)
                    .filter(key => this.state.entities.notes.MLMODALITIES[key].XLMDXLNO === this.xlno &&
                        this.state.entities.notes.MLMODALITIES[key].XLMDPERFORMED === true &&
                        this.state.entities.notes.MLMODALITIES[key].XLMDISGROUP === true).length
                +
                Object.keys(this.state.entities.notes.MLOTHER)
                    .filter(key => this.state.entities.notes.MLOTHER[key].XLOEXLNO === this.xlno &&
                        this.state.entities.notes.MLOTHER[key].XLOEPERFORMED === true &&
                        this.state.entities.notes.MLOTHER[key].XLOEISGROUP === true).length
                +
                Object.keys(this.state.entities.notes.MLSPECIALTYTESTS)
                    .filter(key => this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZXLNO === this.xlno &&
                        this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZPERFORMED === true &&
                        this.state.entities.notes.MLSPECIALTYTESTS[key].XLSZISGROUP === true).length === 0
            ) {
                this.errors.push({ section: 'Charges', label: 'Group Therapy - At least one treatment required', to: 'charges/charges_group' });
            }

        }
    }

}